import React, {
  useMemo,
  useCallback,
  useState,
  useEffect,
  useRef,
  useReducer,
} from "react";
import {
  Archive,
  BarChart,
  Activity,
  Copy,
  GitBranch,
  Phone,
  Droplets,
  Dumbbell,
  Tag,
  Bed,
  UserMinus,
  Globe,
  Printer,
  Child,
  Baby,
  UserCheck,
  Navigation,
  Zap,
  loadingHotels,
  User,
  Filter,
  Ticket,
  Home,
  AlertCircle,
  LogIn,
  AlertTriangle,
  Info,
  ChevronLeft,
  Calendar,
  Plane,
  Hotel,
  CreditCard,
  FileText,
  Users,
  ShoppingCart,
  BarChart3,
  Settings,
  LogOut,
  Menu,
  X,
  Clock,
  MapPin,
  CheckCircle,
  MessageCircle,
  Send,
  Search,
  Loader,
  Building2,
  UserPlus,
  Shield,
  Edit,
  Trash2,
  Eye,
  Plus,
  Save,
  Wifi,
  Coffee,
  Car,
  Star,
  PlusCircle,
  ChevronRight,
  ChevronDown,
  DollarSign,
  Download,
  FileCheck,
  Mail,
  Percent,
  Package,
  Minus,
  RefreshCw,
  ChevronUp,
} from "lucide-react";

import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

import {
  amadeusService,
  API_BASE_URL2,
  confirmToast,
  getAirlineName,
  airports,
  formatPrixCFA,
} from "../constants/utils";

export const MultiFlightCartWorkflow = ({ user, onRequestSubmitted }) => {
  const [activeTab, setActiveTab] = useState("search");
  const [cart, setCart] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [safeSearchParams, setSafeSearchParams] = useState({
    originLocationCode: "",
    destinationLocationCode: "",
    departureDate: "",
    returnDate: "",
    adults: "1",
    children: "0",
    infants: "0",
    tripType: "one-way",
    travelClass: "ECONOMY",
  });
  const [searchParams, setSearchParams] = useState({
    originLocationCode: "",
    destinationLocationCode: "",
    departureDate: "",
    returnDate: "",
    adults: "1",
    children: "0",
    infants: "0",
    tripType: "one-way",
    travelClass: "ECONOMY",
    max: "10",
  });

  const [filters, setFilters] = useState({
    priceRange: [0, 5000], // [min, max] en EUR
    maxStops: null, // null = pas de filtre, 0 = direct, 1 = 1 escale max, etc.
    airlines: [], // Compagnies aériennes sélectionnées
    departureTime: "", // 'morning', 'afternoon', 'evening', 'night'
    sortBy: "price", // 'price', 'duration', 'departure'
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [agents, setAgents] = useState([]);
  const [loadingAgents, setLoadingAgents] = useState(false);

  const [multiCitySegments, setMultiCitySegments] = useState([
    { origin: "", destination: "", date: "" },
  ]);

  // Chargement des agents
  useEffect(() => {
    loadAgents();
  }, []);

  const loadAgents = async () => {
    setLoadingAgents(true);
    try {
      const response = await fetch(`${API_BASE_URL2}/travel-agents`);
      if (!response.ok) throw new Error("Erreur récupération agents");
      const agentsData = await response.json();
      setAgents(agentsData);
    } catch (error) {
      console.error("Erreur lors du chargement des agents:", error);
    } finally {
      setLoadingAgents(false);
    }
  };

  // Fonctions de gestion des segments multi-destinations
  const addSegment = () => {
    if (multiCitySegments.length >= 5) {
      toast.info(
        "Maximum 5 étapes autorisées pour un voyage multi-destinations"
      );
      return;
    }

    const lastSegment = multiCitySegments[multiCitySegments.length - 1];
    const newSegmentDate = lastSegment.date
      ? new Date(new Date(lastSegment.date).getTime() + 24 * 60 * 60 * 1000)
          .toISOString()
          .split("T")[0]
      : new Date().toISOString().split("T")[0];

    setMultiCitySegments([
      ...multiCitySegments,
      {
        origin: lastSegment.destination || "",
        destination: "",
        date: newSegmentDate,
      },
    ]);
  };

  const removeSegment = (index) => {
    if (multiCitySegments.length > 1) {
      const newSegments = multiCitySegments.filter((_, i) => i !== index);
      setMultiCitySegments(newSegments);
    }
  };

  const updateSegment = (index, field, value) => {
    const newSegments = [...multiCitySegments];
    newSegments[index][field] = value;

    // Si on met à jour la destination, propager vers l'origine du segment suivant
    if (field === "destination" && index < multiCitySegments.length - 1) {
      newSegments[index + 1].origin = value;
    }

    // Si on met à jour la date, s'assurer que les dates suivantes sont cohérentes
    if (field === "date") {
      const currentDate = new Date(value);
      for (let i = index + 1; i < newSegments.length; i++) {
        const segmentDate = new Date(newSegments[i].date);
        if (segmentDate <= currentDate) {
          const nextDate = new Date(currentDate);
          nextDate.setDate(nextDate.getDate() + 1);
          newSegments[i].date = nextDate.toISOString().split("T")[0];
          currentDate.setDate(currentDate.getDate() + 1);
        }
      }
    }

    setMultiCitySegments(newSegments);
  };
  // Fonction de recherche de vols
  const handleSearch = async (e, multiCitySegments = []) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    console.log('searchParams',searchParams)

    try {
      let results;

      if (searchParams.tripType === "multi-city") {
        // ==================== RECHERCHE MULTI-DESTINATIONS ====================

        // Vérifier que multiCitySegments est défini
        if (!multiCitySegments || multiCitySegments.length === 0) {
          setError("Aucun segment défini pour la recherche multi-destinations");
          setLoading(false);
          return;
        }

        const invalidSegment = multiCitySegments.find(
          (segment) => !segment.origin || !segment.destination || !segment.date
        );

        if (invalidSegment) {
          setError(
            "Veuillez remplir tous les champs pour chaque segment du voyage multi-destinations"
          );
          setLoading(false);
          return;
        }

        // Vérifier la cohérence des dates
        for (let i = 1; i < multiCitySegments.length; i++) {
          const currentDate = new Date(multiCitySegments[i].date);
          const previousDate = new Date(multiCitySegments[i - 1].date);

          if (currentDate < previousDate) {
            setError(
              `La date de l'étape ${i + 1} doit être après l'étape ${i}`
            );
            setLoading(false);
            return;
          }
        }

        const segmentResults = [];

        // Recherche pour chaque segment
        for (const [index, segment] of multiCitySegments.entries()) {
          try {
            const segmentParams = {
              originLocationCode: segment.origin,
              destinationLocationCode: segment.destination,
              departureDate: segment.date,
              adults: searchParams.adults,
              travelClass: searchParams.travelClass,
              max: "10",
              tripType: "one-way",
            };

            console.log(`Recherche segment ${index + 1}:`, segmentParams);

            const segmentResult = await amadeusService.searchFlights(
              segmentParams
            );

            segmentResults.push({
              segment: {
                ...segment,
                segmentNumber: index + 1,
              },
              flights: segmentResult.data || [],
              searchParams: segmentParams,
              hasResults: segmentResult.data && segmentResult.data.length > 0,
            });

            // Petite pause entre les requêtes
            if (index < multiCitySegments.length - 1) {
              await new Promise((resolve) => setTimeout(resolve, 500));
            }
          } catch (segmentError) {
            console.error(
              `Erreur recherche segment ${index + 1}:`,
              segmentError
            );
            segmentResults.push({
              segment: {
                ...segment,
                segmentNumber: index + 1,
              },
              flights: [],
              searchParams: {},
              hasResults: false,
              error: segmentError.message,
            });
          }
        }

        results = { data: segmentResults };
      } else if (searchParams.tripType === "round-trip") {
        // ==================== RECHERCHE ALLER-RETOUR ====================
        if (!searchParams.returnDate) {
          setError(
            "Veuillez sélectionner une date de retour pour un vol aller-retour"
          );
          setLoading(false);
          return;
        }

        const depDate = new Date(searchParams.departureDate);
        const retDate = new Date(searchParams.returnDate);
        if (retDate <= depDate) {
          setError("La date de retour doit être après la date de départ");
          setLoading(false);
          return;
        }

        try {
          // Recherche vol aller
          const outboundResults = await amadeusService.searchFlights({
            ...searchParams,
            max: "10",
          });

          // Recherche vol retour
          const returnParams = {
            originLocationCode: searchParams.destinationLocationCode,
            destinationLocationCode: searchParams.originLocationCode,
            departureDate: searchParams.returnDate,
            adults: searchParams.adults,
            travelClass: searchParams.travelClass,
            max: "10",
            tripType: "one-way",
          };

          const returnResults = await amadeusService.searchFlights(
            returnParams
          );

          const allResults = [
            ...(outboundResults.data || []).map((f) => ({
              ...f,
              isOutbound: true,
              searchParams: {
                ...searchParams,
                tripType: "outbound",
              },
            })),
            ...(returnResults.data || []).map((f) => ({
              ...f,
              isReturn: true,
              searchParams: {
                ...returnParams,
                tripType: "return",
              },
            })),
          ];

          results = { data: allResults };
        } catch (roundTripError) {
          console.error("Erreur recherche aller-retour:", roundTripError);
          throw new Error("Erreur lors de la recherche aller-retour");
        }
      } else {
        // ==================== RECHERCHE ALLER SIMPLE ====================
        try {
          const oneWayParams = {
            ...searchParams,
            max: "10",
            tripType: "one-way",
          };

          results = await amadeusService.searchFlights(oneWayParams);

          if (results.data) {
            results.data = results.data.map((flight) => ({
              ...flight,
              searchParams: oneWayParams,
            }));
          }
        } catch (oneWayError) {
          console.error("Erreur recherche aller simple:", oneWayError);
          throw new Error("Erreur lors de la recherche de vols");
        }
      }

      // Traitement des résultats
      if (searchParams.tripType === "multi-city") {
        setSearchResults(results.data || []);

        const hasAnyResults =
          results.data &&
          results.data.some((segment) => segment.flights.length > 0);
        if (!hasAnyResults) {
          setError(
            "Aucun vol trouvé pour votre itinéraire multi-destinations."
          );
        } else {
          const segmentsWithoutResults = results.data
            .filter((segment) => segment.flights.length === 0)
            .map((segment) => segment.segment.segmentNumber);

          if (segmentsWithoutResults.length > 0) {
            setError(
              `Aucun vol trouvé pour ${
                segmentsWithoutResults.length > 1
                  ? "les segments"
                  : "le segment"
              } ${segmentsWithoutResults.join(
                ", "
              )}. Vous pouvez modifier votre recherche ou continuer avec les segments disponibles.`
            );
          }
        }
      } else {
        setSearchResults(results.data || []);

        if (!results.data || results.data.length === 0) {
          setError("Aucun vol trouvé pour ces critères.");
        }
      }
    } catch (err) {
      console.error("Erreur recherche vols:", err);

      if (err.message.includes("network") || err.message.includes("fetch")) {
        setError(
          "Erreur de connexion. Veuillez vérifier votre connexion internet et réessayer."
        );
      } else if (
        err.message.includes("quota") ||
        err.message.includes("rate limit")
      ) {
        setError(
          "Limite de requêtes atteinte. Veuillez réessayer dans quelques instants."
        );
      } else if (
        err.message.includes("origin") ||
        err.message.includes("destination")
      ) {
        setError(
          "Code aéroport invalide. Veuillez vérifier les codes IATA saisis."
        );
      } else {
        setError("Erreur lors de la recherche. Veuillez réessayer.");
      }
    } finally {
      setLoading(false);
    }
  };

  // FONCTIONS DE GESTION DU PANIER - DÉFINIES AU NIVEAU PRINCIPAL

  const addToCart = (flight) => {
    toast.success("L’ajout du vol à votre panier a été effectué avec succès.");

    // confirmToast(
    //   "Voulez-vous vraiment ajouter ce vol à votre panier ?",
    //   () => toast.success("Vol ajouté avec succès !"),
    //   () => toast.info("Action annulée.")
    // );

    const tickets = [];

    // Récupérer les nombres de passagers depuis les searchParams
    const adults = parseInt(
      flight.searchParams?.adults || searchParams.adults || 1
    );
    const children = parseInt(
      flight.searchParams?.children || searchParams.children || 0
    );
    const infants = parseInt(
      flight.searchParams?.infants || searchParams.infants || 0
    );

    const totalPassengers = adults + children + infants;

    // Extraire les informations du vol
    const firstItinerary = flight.itineraries?.[0];
    const firstSegment = firstItinerary?.segments?.[0];
    const lastSegment =
      firstItinerary?.segments?.[firstItinerary.segments.length - 1];

    let passengerCounter = 0;

    // Créer des tickets pour les ADULTES
    for (let i = 0; i < adults; i++) {
      passengerCounter++;
      tickets.push(
        createTicket(
          flight,
          firstSegment,
          lastSegment,
          firstItinerary,
          "ADULT",
          passengerCounter
        )
      );
    }

    // Créer des tickets pour les ENFANTS
    for (let i = 0; i < children; i++) {
      passengerCounter++;
      tickets.push(
        createTicket(
          flight,
          firstSegment,
          lastSegment,
          firstItinerary,
          "CHILD",
          passengerCounter
        )
      );
    }

    // Créer des tickets pour les BÉBÉS
    for (let i = 0; i < infants; i++) {
      passengerCounter++;
      tickets.push(
        createTicket(
          flight,
          firstSegment,
          lastSegment,
          firstItinerary,
          "HELD_INFANT",
          passengerCounter
        )
      );
    }

    // Ajouter tous les tickets au panier
    setCart((prevCart) => [...prevCart, ...tickets]);
  };

  // Fonction helper pour créer un ticket
  const createTicket = (
    flight,
    firstSegment,
    lastSegment,
    firstItinerary,
    passengerType,
    passengerNumber
  ) => {
    // Trouver le prix correspondant au type de passager dans travelerPricings
    const travelerPricing = flight.travelerPricings?.find(
      (tp) => tp.travelerType === passengerType && tp.travelerId === passengerNumber.toString()
    );

    // Si on ne trouve pas de correspondance exacte, chercher par type uniquement
    const pricingByType = travelerPricing || 
      flight.travelerPricings?.find((tp) => tp.travelerType === passengerType);

    // Utiliser le prix réel du travelerPricing
    const finalPrice = parseFloat(pricingByType?.price?.total || 0);
    const currency = pricingByType?.price?.currency || flight.price?.currency || "EUR";

    return {
      id: `${flight.id}-${passengerType}-${passengerNumber}-${Date.now()}`,
      flightData: {
        ...flight,
        departure: {
          iataCode: firstSegment?.departure?.iataCode,
          at: firstSegment?.departure?.at,
        },
        arrival: {
          iataCode: lastSegment?.arrival?.iataCode,
          at: lastSegment?.arrival?.at,
        },
        airline: {
          code: firstSegment?.carrierCode,
          number: firstSegment?.number,
        },
        duration: firstItinerary?.duration,
        segments: firstItinerary?.segments,
      },
      passengerType: passengerType,
      passengerNumber: passengerNumber,
      price: {
        total: finalPrice.toFixed(2),
        currency: currency,
      },
      searchParams: flight.searchParams || {
        adults: searchParams.adults,
        children: searchParams.children,
        infants: searchParams.infants,
        travelClass:
          flight.travelerPricings?.[0]?.fareDetailsBySegment?.[0]?.cabin ||
          "ECONOMY",
      },
      addedAt: new Date().toISOString(),
    };
  };

  // Fonction utilitaire pour calculer le prix par type de passager
  const calculatePassengerPrice = (totalPrice, passengerType, currency) => {
    const totalPassengers =
      parseInt(searchParams.adults) +
      parseInt(searchParams.children) +
      parseInt(searchParams.infants);
    const basePrice = parseFloat(totalPrice) / totalPassengers;

    switch (passengerType) {
      case "CHILD":
        return {
          total: (basePrice * 0.75).toFixed(2), // 25% de réduction pour les enfants
          currency: currency,
        };
      case "INFANT":
        return {
          total: (basePrice * 0.1).toFixed(2), // 90% de réduction pour les bébés
          currency: currency,
        };
      default:
        return {
          total: basePrice.toFixed(2),
          currency: currency,
        };
    }
  };
  const removeFromCart = (cartId) => {
    confirmToast(
      "Êtes-vous sûr de vouloir retirer du panier ?",
      () => {
        setCart(cart.filter((item) => item.id !== cartId));
        toast.success("Vol retiré du panier !");
      },
      () => toast.info("Action annulée.")
    );
  };

  const calculateCartTotal = () => {
    const t = cart
      .reduce((total, item) => {
        const price = parseFloat(item.price?.total || 0);
        return total + price;
      }, 0)
      .toFixed(2);
    return formatPrixCFA(t);
  };

  const clearCart = () => {
    confirmToast(
      "Êtes-vous sûr de vouloir vider le panier ?",
      () => {
        setCart([]);
        toast.success("Panier vidé avec succès !");
      },
      () => toast.info("Action annulée.")
    );
  };

  const handleFinalizeRequest = (searchParams) => {
    if (cart.length === 0) {
      toast.info(
        "Votre panier est vide. Veuillez ajouter des vols avant de finaliser."
      );
      return;
    }
    setActiveTab("finalize"); // Changé de 'form' à 'finalize'
  };

  // Ajouter cette fonction pour revenir au panier
  const handleBackToCart = () => {
    setActiveTab("cart");
  };

  // COMPOSANT CARTTAB CORRIGÉ - AVEC ACCÈS DIRECT AU STATE PARENT
  const CartTab = () => {
    // Fonction pour formater la durée
    const formatDuration = (duration) => {
      if (!duration) return "N/A";
      const match = duration.match(/PT(?:(\d+)H)?(?:(\d+)M)?/);
      const hours = match[1] ? parseInt(match[1]) : 0;
      const minutes = match[2] ? parseInt(match[2]) : 0;

      if (hours > 0 && minutes > 0) {
        return `${hours}h ${minutes}min`;
      } else if (hours > 0) {
        return `${hours}h`;
      } else {
        return `${minutes}min`;
      }
    };

    if (cart.length === 0) {
      return (
        <div className="bg-white rounded-xl shadow-md p-12 text-center">
          <ShoppingCart className="w-16 h-16 text-gray-300 mx-auto mb-4" />
          <h3 className="text-xl font-bold text-gray-700 mb-2">
            Votre panier est vide
          </h3>
          <p className="text-gray-500 mb-6">
            Recherchez et ajoutez des vols à votre panier
          </p>
          <button
            onClick={() => setActiveTab("search")}
            className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700"
          >
            Rechercher des vols
          </button>
        </div>
      );
    }

    return (
      <div className="space-y-6">
        <div className="bg-white rounded-xl shadow-md p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-xl font-bold flex items-center">
              <ShoppingCart className="w-6 h-6 mr-2 text-blue-600" />
              Mon Panier ({cart.length} ticket{cart.length > 1 ? "s" : ""})
            </h2>
            <button
              onClick={clearCart}
              className="text-red-600 hover:bg-red-50 px-4 py-2 rounded-lg flex items-center"
            >
              <Trash2 className="w-4 h-4 mr-2" />
              Vider le panier
            </button>
          </div>

          <div className="space-y-4">
            {cart.map((ticket, index) => {
              const firstItinerary =
                ticket.flightData?.itineraries?.[0] || ticket.itineraries?.[0];
              const firstSegment = firstItinerary?.segments?.[0];
              const lastSegment =
                firstItinerary?.segments?.[firstItinerary.segments.length - 1];
              const carrierCode = firstSegment?.carrierCode;
              const flightNumber = firstSegment?.number;

              return (
                <div
                  key={ticket.id || ticket.cartId}
                  className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition"
                >
                  <div className="flex justify-between items-start">
                    <div className="flex-1">
                      {/* En-tête avec informations principales */}
                      <div className="flex items-center space-x-3 mb-3">
                        <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm font-semibold">
                          Ticket #{index + 1}
                        </span>
                        <h4 className="font-bold text-lg text-gray-800">
                          {firstSegment?.departure?.iataCode ||
                            ticket.flightData?.departure?.iataCode ||
                            "N/A"}{" "}
                          →
                          {lastSegment?.arrival?.iataCode ||
                            ticket.flightData?.arrival?.iataCode ||
                            "N/A"}
                        </h4>
                        <span className="px-2 py-1 bg-green-100 text-green-700 rounded text-sm font-medium">
                          {getAirlineName(
                            carrierCode || ticket.flightData?.airline?.code
                          )}
                          {" ("}
                          {carrierCode} {flightNumber ? ` ${flightNumber}` : ""}
                          {")"}
                        </span>
                      </div>

                      {/* Grille d'informations détaillées */}
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 text-sm">
                        {/* Départ */}
                        <div className="flex items-center space-x-2">
                          <Calendar className="w-4 h-4 text-gray-400" />
                          <div>
                            <p className="text-gray-500">Départ</p>
                            <p className="font-semibold">
                              {firstSegment?.departure?.at ||
                              ticket.flightData?.departure?.at
                                ? new Date(
                                    firstSegment?.departure?.at ||
                                      ticket.flightData?.departure?.at
                                  ).toLocaleString("fr-FR", {
                                    day: "2-digit",
                                    month: "short",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  })
                                : "N/A"}
                            </p>
                            <p className="text-xs text-gray-400">
                              {firstSegment?.departure?.iataCode ||
                                ticket.flightData?.departure?.iataCode}
                            </p>
                          </div>
                        </div>

                        {/* Arrivée */}
                        <div className="flex items-center space-x-2">
                          <Plane className="w-4 h-4 text-gray-400" />
                          <div>
                            <p className="text-gray-500">Arrivée</p>
                            <p className="font-semibold">
                              {lastSegment?.arrival?.at ||
                              ticket.flightData?.arrival?.at
                                ? new Date(
                                    lastSegment?.arrival?.at ||
                                      ticket.flightData?.arrival?.at
                                  ).toLocaleString("fr-FR", {
                                    day: "2-digit",
                                    month: "short",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  })
                                : "N/A"}
                            </p>
                            <p className="text-xs text-gray-400">
                              {lastSegment?.arrival?.iataCode ||
                                ticket.flightData?.arrival?.iataCode}
                            </p>
                          </div>
                        </div>

                        {/* Durée et informations vol */}
                        <div className="flex items-center space-x-2">
                          <Clock className="w-4 h-4 text-gray-400" />
                          <div>
                            <p className="text-gray-500">Durée</p>
                            <p className="font-semibold">
                              {formatDuration(
                                firstItinerary?.duration ||
                                  ticket.flightData?.duration
                              )}
                            </p>
                            <p className="text-xs text-gray-400">
                              {firstItinerary?.segments?.length === 1
                                ? "Vol direct"
                                : `${
                                    firstItinerary?.segments?.length - 1
                                  } escale${
                                    firstItinerary?.segments?.length > 2
                                      ? "s"
                                      : ""
                                  }`}
                            </p>
                          </div>
                        </div>

                        {/* Informations passager */}
                        <div className="flex items-center space-x-2">
                          <User className="w-4 h-4 text-gray-400" />
                          <div>
                            <p className="text-gray-500">Passager</p>
                            <p className="font-semibold">
                              {ticket.passengerType === "ADULT"
                                ? "Adulte"
                                : ticket.passengerType === "CHILD"
                                ? "Enfant"
                                : "Bébé"}{" "}
                              #{ticket.passengerNumber || "1"}
                            </p>
                            <p className="text-xs text-gray-400">
                              Classe:{" "}
                              {ticket.searchParams?.travelClass ||
                                ticket.flightData?.searchParams?.travelClass ||
                                "ECONOMY"}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Prix et actions */}
                    <div className="text-right ml-4">
                      <p className="text-2xl font-bold text-blue-600">
                        {formatPrixCFA(ticket.price?.total) ||
                          formatPrixCFA(ticket.flightData?.price?.total) ||
                          "0"}
                        {/* {ticket.price?.currency ||
                          ticket.flightData?.price?.currency ||
                          "EUR"} */}
                      </p>
                      <button
                        onClick={() => {
                          removeFromCart(ticket.id || ticket.cartId);
                        }}
                        className="mt-2 bg-red-600 text-white px-3 py-2 rounded-lg text-sm hover:bg-red-700 flex items-center"
                      >
                        <Trash2 className="w-4 h-4 mr-1" />
                        Supprimer
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Résumé et total */}
          <div className="mt-6 pt-6 border-t">
            <div className="flex justify-between items-center text-xl font-bold">
              <span>Total du panier:</span>
              <span className="text-3xl text-blue-600">
                {calculateCartTotal()}{" "}
                {/* {cart[0]?.price?.currency ||
                  cart[0]?.flightData?.price?.currency ||
                  "EUR"} */}
              </span>
            </div>

            {/* Détail du total par type de passager */}
            <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4 text-sm text-gray-600">
              <div>
                <span className="font-semibold">Adultes:</span>{" "}
                {cart.filter((t) => t.passengerType === "ADULT").length}
              </div>
              <div>
                <span className="font-semibold">Enfants:</span>{" "}
                {cart.filter((t) => t.passengerType === "CHILD").length}
              </div>
              <div>
                <span className="font-semibold">Bébés:</span>{" "}
                {cart.filter((t) => t.passengerType === "INFANT").length}
              </div>
            </div>
          </div>

          {/* Boutons d'action */}
          <div className="flex space-x-4 mt-6">
            <button
              onClick={() => setActiveTab("search")}
              className="flex-1 border border-blue-600 text-blue-600 py-3 rounded-lg font-semibold hover:bg-blue-50 transition"
            >
              Continuer les achats
            </button>
            <button
              onClick={handleFinalizeRequest}
              className="flex-1 bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-indigo-700 transition flex items-center justify-center"
            >
              <FileText className="w-5 h-5 mr-2" />
              Finaliser la demande
            </button>
          </div>
        </div>
      </div>
    );
  };
  // COMPOSANT SEARCHTAB CORRIGÉ - AVEC ACCÈS À addToCart
  const SearchTab = ({
    searchParams,
    setSearchParams,
    handleSearch,
    loading,
    error,
    searchResults,
    addToCart,
    cart,
  }) => {
    console.log("les paramètre xx", searchParams);
    const [multiCitySegments, setMultiCitySegments] = useState([
      { origin: "", destination: "", date: "" },
    ]);

    const totalPassengers =
      parseInt(searchParams.adults) +
      parseInt(searchParams.children) +
      parseInt(searchParams.infants);
    // États pour les filtres
    const [filters, setFilters] = useState({
      priceRange: [0, 50000000],
      maxStops: null,
      departureTime: "",
      sortBy: "price",
    });

    const safeSearchParams = {
      tripType: "one-way",
      ...searchParams,
    };

    // Fonction pour obtenir les numéros de vol
    const getFlightNumbers = (flight) => {
      const segments = flight.itineraries?.[0]?.segments || [];
      if (segments.length === 0) return "N/A";

      return segments
        .map((segment) => `${segment.carrierCode} ${segment.number}`)
        .join(" → ");
    };

    // Fonction pour obtenir les détails des segments
    const getFlightSegmentsDetails = (flight) => {
      const segments = flight.itineraries?.[0]?.segments || [];
      return segments.map((segment, index) => ({
        number: `${segment.carrierCode} ${segment.number}`,
        route: `${segment.departure?.iataCode} → ${segment.arrival?.iataCode}`,
        departureTime: segment.departure?.at
          ? new Date(segment.departure.at).toLocaleTimeString("fr-FR", {
              hour: "2-digit",
              minute: "2-digit",
            })
          : "N/A",
        arrivalTime: segment.arrival?.at
          ? new Date(segment.arrival.at).toLocaleTimeString("fr-FR", {
              hour: "2-digit",
              minute: "2-digit",
            })
          : "N/A",
        duration:
          segment.duration
            ?.replace("PT", "")
            .replace("H", "h ")
            .replace("M", "min") || "N/A",
        isLast: index === segments.length - 1,
      }));
    };

    // Gestion des segments multi-destinations
    const addSegment = () => {
      const lastSegment = multiCitySegments[multiCitySegments.length - 1];
      const newSegmentDate = lastSegment.date
        ? new Date(new Date(lastSegment.date).getTime() + 24 * 60 * 60 * 1000)
            .toISOString()
            .split("T")[0]
        : "";

      setMultiCitySegments([
        ...multiCitySegments,
        {
          origin: lastSegment.destination || "",
          destination: "",
          date: newSegmentDate,
        },
      ]);
    };

    const removeSegment = (index) => {
      if (multiCitySegments.length > 1) {
        setMultiCitySegments(multiCitySegments.filter((_, i) => i !== index));
      }
    };

    const updateSegment = (index, field, value) => {
      const updated = [...multiCitySegments];
      updated[index][field] = value;
      setMultiCitySegments(updated);
    };

    const handleTripTypeChange = (type) => {
      setSearchParams({
        ...safeSearchParams,
        tripType: type,
        returnDate: type === "one-way" ? "" : safeSearchParams.returnDate,
      });

      if (type !== "multi-city") {
        setMultiCitySegments([{ origin: "", destination: "", date: "" }]);
      }
    };

    // FONCTION filterSearchResults CORRIGÉE ET DÉFINIE
    const filterSearchResults = (results, filters, searchParams) => {
      if (!results || results.length === 0) return [];

      let filtered = [...results];

      // Pour les recherches multi-destinations
      if (searchParams.tripType === "multi-city") {
        filtered = filtered
          .map((segmentGroup) => ({
            ...segmentGroup,
            flights: segmentGroup.flights.filter((flight) => {
              const price = parseFloat(flight.price?.total || 0);
              const numberOfStops =
                (flight.itineraries?.[0]?.segments?.length || 1) - 1;
              const departureTime =
                flight.itineraries?.[0]?.segments?.[0]?.departure?.at;

              // Filtre prix
              if (price > filters.priceRange[1]) return false;

              // Filtre nombre d'escales
              if (filters.maxStops !== null && numberOfStops > filters.maxStops)
                return false;

              // Filtre heure de départ
              if (filters.departureTime && departureTime) {
                const hour = new Date(departureTime).getHours();
                switch (filters.departureTime) {
                  case "morning":
                    if (hour < 6 || hour >= 12) return false;
                    break;
                  case "afternoon":
                    if (hour < 12 || hour >= 18) return false;
                    break;
                  case "evening":
                    if (hour < 18 || hour >= 24) return false;
                    break;
                  case "night":
                    if (hour >= 6 && hour < 24) return false;
                    break;
                }
              }

              return true;
            }),
          }))
          .filter((segmentGroup) => segmentGroup.flights.length > 0);
      } else {
        // Pour les recherches standard
        filtered = filtered.filter((flight) => {
          const price = parseFloat(flight.price?.total || 0);
          const numberOfStops =
            (flight.itineraries?.[0]?.segments?.length || 1) - 1;
          const departureTime =
            flight.itineraries?.[0]?.segments?.[0]?.departure?.at;

          // Filtre prix
          if (price > filters.priceRange[1]) return false;

          // Filtre nombre d'escales
          if (filters.maxStops !== null && numberOfStops > filters.maxStops)
            return false;

          // Filtre heure de départ
          if (filters.departureTime && departureTime) {
            const hour = new Date(departureTime).getHours();
            switch (filters.departureTime) {
              case "morning":
                if (hour < 6 || hour >= 12) return false;
                break;
              case "afternoon":
                if (hour < 12 || hour >= 18) return false;
                break;
              case "evening":
                if (hour < 18 || hour >= 24) return false;
                break;
              case "night":
                if (hour >= 6 && hour < 24) return false;
                break;
            }
          }

          return true;
        });
      }

      // Tri des résultats
      if (searchParams.tripType === "multi-city") {
        filtered.forEach((segmentGroup) => {
          segmentGroup.flights.sort((a, b) => {
            const priceA = parseFloat(a.price?.total || 0);
            const priceB = parseFloat(b.price?.total || 0);
            const durationA = a.itineraries?.[0]?.duration || "";
            const durationB = b.itineraries?.[0]?.duration || "";
            const departureA =
              a.itineraries?.[0]?.segments?.[0]?.departure?.at || "";
            const departureB =
              b.itineraries?.[0]?.segments?.[0]?.departure?.at || "";

            switch (filters.sortBy) {
              case "price":
                return priceA - priceB;
              case "price_desc":
                return priceB - priceA;
              case "duration":
                return durationA.localeCompare(durationB);
              case "departure":
                return new Date(departureA) - new Date(departureB);
              default:
                return priceA - priceB;
            }
          });
        });
      } else {
        filtered.sort((a, b) => {
          const priceA = parseFloat(a.price?.total || 0);
          const priceB = parseFloat(b.price?.total || 0);
          const durationA = a.itineraries?.[0]?.duration || "";
          const durationB = b.itineraries?.[0]?.duration || "";
          const departureA =
            a.itineraries?.[0]?.segments?.[0]?.departure?.at || "";
          const departureB =
            b.itineraries?.[0]?.segments?.[0]?.departure?.at || "";

          switch (filters.sortBy) {
            case "price":
              return priceA - priceB;
            case "price_desc":
              return priceB - priceA;
            case "duration":
              return durationA.localeCompare(durationB);
            case "departure":
              return new Date(departureA) - new Date(departureB);
            default:
              return priceA - priceB;
          }
        });
      }

      return filtered;
    };

    // Résultats filtrés
    const filteredResults = filterSearchResults(
      searchResults,
      filters,
      safeSearchParams
    );

    // Composant de filtres
    const FiltersSection = () => {
      const [showFilters, setShowFilters] = useState(false);

      // Calculer les prix min/max disponibles
      const availablePrices = searchResults
        .flatMap((result) =>
          safeSearchParams.tripType === "multi-city"
            ? result.flights.map((f) => parseFloat(f.price?.total || 0))
            : [parseFloat(result.price?.total || 0)]
        )
        .filter((price) => price > 0);

      const minPrice =
        availablePrices.length > 0 ? Math.min(...availablePrices) : 0;
      const maxPrice =
        availablePrices.length > 0 ? Math.max(...availablePrices) : 5000;

      return (
        <div className="bg-white rounded-lg shadow-sm border p-4 mb-6">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-semibold flex items-center">
              <Filter className="w-5 h-5 mr-2 text-blue-600" />
              Filtres
            </h3>
            <button
              onClick={() => setShowFilters(!showFilters)}
              className="text-blue-600 hover:text-blue-800 flex items-center"
            >
              {showFilters ? "Masquer les filtres" : "Afficher les filtres"}
              <ChevronDown
                className={`w-4 h-4 ml-1 transition-transform ${
                  showFilters ? "rotate-180" : ""
                }`}
              />
            </button>
          </div>

          {showFilters && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 border-t pt-4">
              {/* Filtre par prix */}
              <div>
                <label className="block text-sm font-semibold mb-3 text-gray-700">
                  💰 Prix maximum
                </label>
                <div className="space-y-2">
                  <input
                    type="range"
                    min={minPrice}
                    max={maxPrice}
                    value={filters.priceRange[1]}
                    onChange={(e) =>
                      setFilters((prev) => ({
                        ...prev,
                        priceRange: [
                          prev.priceRange[0],
                          parseInt(e.target.value),
                        ],
                      }))
                    }
                    className="w-full h-2 bg-blue-200 rounded-lg appearance-none cursor-pointer"
                  />
                  <div className="flex justify-between text-sm text-gray-600">
                    <span>{minPrice} €</span>
                    <span className="font-semibold text-blue-600">
                      {filters.priceRange[1]} €
                    </span>
                    <span>{maxPrice} €</span>
                  </div>
                </div>
              </div>

              {/* Filtre par nombre d'escales */}
              <div>
                <label className="block text-sm font-semibold mb-3 text-gray-700">
                  🛑 Nombre d'escales
                </label>
                <div className="space-y-2">
                  {[
                    { value: null, label: "Toutes" },
                    { value: 0, label: "Vols directs" },
                    { value: 1, label: "1 escale max" },
                    { value: 2, label: "2 escales max" },
                  ].map((option) => (
                    <label
                      key={option.value}
                      className="flex items-center space-x-2 cursor-pointer"
                    >
                      <input
                        type="radio"
                        name="stops"
                        value={option.value}
                        checked={filters.maxStops === option.value}
                        onChange={() =>
                          setFilters((prev) => ({
                            ...prev,
                            maxStops: option.value,
                          }))
                        }
                        className="text-blue-600 focus:ring-blue-500"
                      />
                      <span className="text-sm">{option.label}</span>
                    </label>
                  ))}
                </div>
              </div>

              {/* Filtre par heure de départ */}
              <div>
                <label className="block text-sm font-semibold mb-3 text-gray-700">
                  ⏰ Heure de départ
                </label>
                <select
                  value={filters.departureTime}
                  onChange={(e) =>
                    setFilters((prev) => ({
                      ...prev,
                      departureTime: e.target.value,
                    }))
                  }
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  <option value="">Toutes heures</option>
                  <option value="morning">Matin (6h - 12h)</option>
                  <option value="afternoon">Après-midi (12h - 18h)</option>
                  <option value="evening">Soir (18h - 24h)</option>
                  <option value="night">Nuit (0h - 6h)</option>
                </select>
              </div>

              {/* Tri des résultats */}
              <div>
                <label className="block text-sm font-semibold mb-3 text-gray-700">
                  🔄 Trier par
                </label>
                <select
                  value={filters.sortBy}
                  onChange={(e) =>
                    setFilters((prev) => ({ ...prev, sortBy: e.target.value }))
                  }
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  <option value="price">Prix (croissant)</option>
                  <option value="price_desc">Prix (décroissant)</option>
                  <option value="duration">Durée (plus court)</option>
                  <option value="departure">Heure de départ</option>
                </select>
              </div>
            </div>
          )}

          {/* Filtres actifs */}
          <div className="flex flex-wrap gap-2 mt-4">
            {filters.priceRange[1] < maxPrice && (
              <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm flex items-center">
                💰 Jusqu'à {filters.priceRange[1]} €
                <button
                  onClick={() =>
                    setFilters((prev) => ({
                      ...prev,
                      priceRange: [0, maxPrice],
                    }))
                  }
                  className="ml-2 text-blue-600 hover:text-blue-800"
                >
                  ×
                </button>
              </span>
            )}

            {filters.maxStops !== null && (
              <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm flex items-center">
                🛑{" "}
                {filters.maxStops === 0
                  ? "Vols directs"
                  : `${filters.maxStops} escale${
                      filters.maxStops > 1 ? "s" : ""
                    } max`}
                <button
                  onClick={() =>
                    setFilters((prev) => ({ ...prev, maxStops: null }))
                  }
                  className="ml-2 text-green-600 hover:text-green-800"
                >
                  ×
                </button>
              </span>
            )}

            {filters.departureTime && (
              <span className="bg-purple-100 text-purple-800 px-3 py-1 rounded-full text-sm flex items-center">
                ⏰{" "}
                {
                  {
                    morning: "Matin",
                    afternoon: "Après-midi",
                    evening: "Soir",
                    night: "Nuit",
                  }[filters.departureTime]
                }
                <button
                  onClick={() =>
                    setFilters((prev) => ({ ...prev, departureTime: "" }))
                  }
                  className="ml-2 text-purple-600 hover:text-purple-800"
                >
                  ×
                </button>
              </span>
            )}
          </div>
        </div>
      );
    };

    return (
      <div className="space-y-6">
        {/* Formulaire de recherche */}
        <div className="bg-white rounded-xl shadow-md p-6">
          <h2 className="text-xl font-bold mb-4">Rechercher des vols</h2>

          <form
            onSubmit={(e) =>
              handleSearch(
                e,
                safeSearchParams.tripType === "multi-city"
                  ? multiCitySegments
                  : []
              )
            }
            className="space-y-6"
          >
            {/* Sélection du type de voyage */}
            <div className="bg-blue-50 rounded-xl p-6 border border-blue-200">
              <label className="block text-lg font-bold text-gray-800 mb-4">
                Type de voyage *
              </label>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <button
                  type="button"
                  onClick={() => handleTripTypeChange("one-way")}
                  className={`p-4 rounded-xl font-semibold transition-all duration-200 ${
                    safeSearchParams.tripType === "one-way"
                      ? "bg-blue-600 text-white shadow-lg transform scale-105"
                      : "bg-white text-gray-700 border-2 border-gray-300 hover:border-blue-400 hover:shadow-md"
                  }`}
                >
                  <div className="flex flex-col items-center space-y-2">
                    <Plane className="w-6 h-6" />
                    <span>Aller simple</span>
                    <p className="text-xs opacity-80">Un seul trajet</p>
                  </div>
                </button>

                <button
                  type="button"
                  onClick={() => handleTripTypeChange("round-trip")}
                  className={`p-4 rounded-xl font-semibold transition-all duration-200 ${
                    safeSearchParams.tripType === "round-trip"
                      ? "bg-blue-600 text-white shadow-lg transform scale-105"
                      : "bg-white text-gray-700 border-2 border-gray-300 hover:border-blue-400 hover:shadow-md"
                  }`}
                >
                  <div className="flex flex-col items-center space-y-2">
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
                      />
                    </svg>
                    <span>Aller-retour</span>
                    <p className="text-xs opacity-80">Aller + retour</p>
                  </div>
                </button>

                <button
                  type="button"
                  onClick={() => handleTripTypeChange("multi-city")}
                  className={`p-4 rounded-xl font-semibold transition-all duration-200 ${
                    safeSearchParams.tripType === "multi-city"
                      ? "bg-blue-600 text-white shadow-lg transform scale-105"
                      : "bg-white text-gray-700 border-2 border-gray-300 hover:border-blue-400 hover:shadow-md"
                  }`}
                >
                  <div className="flex flex-col items-center space-y-2">
                    <MapPin className="w-6 h-6" />
                    <span>Multi-destinations</span>
                    <p className="text-xs opacity-80">Plusieurs étapes</p>
                  </div>
                </button>
              </div>
            </div>

            {/* Formulaire selon le type de voyage */}
            <div className="bg-white rounded-xl shadow-md p-6 border">
              {safeSearchParams.tripType === "multi-city" ? (
                // FORMULAIRE MULTI-DESTINATIONS
                <div className="space-y-6">
                  <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
                    <MapPin className="w-5 h-5 mr-2 text-blue-600" />
                    Itinéraire Multi-Destinations
                  </h3>

                  <div className="space-y-4">
                    {multiCitySegments.map((segment, index) => (
                      <div
                        key={index}
                        className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-6 border-2 border-blue-200 relative"
                      >
                        <div className="absolute -top-3 -left-3 bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold text-sm">
                          {index + 1}
                        </div>

                        <div className="flex justify-between items-center mb-4">
                          <h4 className="font-semibold text-gray-800 text-lg">
                            Étape {index + 1}
                          </h4>
                          {multiCitySegments.length > 1 && (
                            <button
                              type="button"
                              onClick={() => removeSegment(index)}
                              className="text-red-600 hover:text-red-800 bg-red-50 p-2 rounded-lg transition-colors"
                            >
                              <Trash2 className="w-4 h-4" />
                            </button>
                          )}
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                          <div>
                            <label className="block text-sm font-semibold mb-2">
                              Départ (Code IATA) *
                            </label>
                            <select
                              value={segment.origin}
                              onChange={(e) =>
                                updateSegment(index, "origin", e.target.value)
                              }
                              className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500"
                              required
                            >
                              <option value="">Sélectionnez un aéroport</option>
                              {airports.map((group) => (
                                <optgroup key={group.label} label={group.label}>
                                  {group.options.map((airport) => (
                                    <option
                                      key={airport.value}
                                      value={airport.value}
                                    >
                                      {airport.label}
                                    </option>
                                  ))}
                                </optgroup>
                              ))}
                            </select>
                          </div>

                          <div>
                            <label className="block text-sm font-semibold mb-2">
                              Arrivée (Code IATA) *
                            </label>
                            <select
                              value={segment.destination}
                              onChange={(e) =>
                                updateSegment(
                                  index,
                                  "destination",
                                  e.target.value
                                )
                              }
                              className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500"
                              required
                            >
                              <option value="">Sélectionnez un aéroport</option>
                              {airports.map((group) => (
                                <optgroup key={group.label} label={group.label}>
                                  {group.options.map((airport) => (
                                    <option
                                      key={airport.value}
                                      value={airport.value}
                                    >
                                      {airport.label}
                                    </option>
                                  ))}
                                </optgroup>
                              ))}
                            </select>
                          </div>

                          <div>
                            <label className="block text-sm font-semibold mb-2">
                              Date de vol *
                            </label>
                            <input
                              type="date"
                              value={segment.date}
                              onChange={(e) =>
                                updateSegment(index, "date", e.target.value)
                              }
                              min={
                                index > 0
                                  ? multiCitySegments[index - 1].date
                                  : new Date().toISOString().split("T")[0]
                              }
                              className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500"
                              required
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  <button
                    type="button"
                    onClick={addSegment}
                    className="w-full bg-gradient-to-r from-green-500 to-emerald-500 text-white py-3 rounded-lg font-semibold hover:from-green-600 hover:to-emerald-600 transition flex items-center justify-center"
                  >
                    <PlusCircle className="w-5 h-5 mr-2" />
                    Ajouter une étape (Maximum 5)
                  </button>
                </div>
              ) : (
                // FORMULAIRE STANDARD
                <div className="space-y-6">
                  <h3 className="text-xl font-bold text-gray-800 mb-4">
                    {safeSearchParams.tripType === "one-way"
                      ? "Vol Aller Simple"
                      : "Vol Aller-Retour"}
                  </h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {/* Champs de formulaire standards */}
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Départ *
                      </label>
                      <select
                        value={safeSearchParams.originLocationCode}
                        onChange={(e) =>
                          setSearchParams((prev) => ({
                            ...prev,
                            originLocationCode: e.target.value,
                          }))
                        }
                        className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                        required
                      >
                        <option value="">Sélectionnez un aéroport</option>
                        {/* Afrique */}
                        {airports.map((group) => (
                          <optgroup key={group.label} label={group.label}>
                            {group.options.map((airport) => (
                              <option key={airport.value} value={airport.value}>
                                {airport.label}
                              </option>
                            ))}
                          </optgroup>
                        ))}
                      </select>
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Arrivée *
                      </label>
                      <select
                        value={safeSearchParams.destinationLocationCode}
                        onChange={(e) =>
                          setSearchParams((prev) => ({
                            ...prev,
                            destinationLocationCode: e.target.value,
                          }))
                        }
                        className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                        required
                      >
                        <option value="">Sélectionnez un aéroport</option>
                        {/* Afrique */}
                        {airports.map((group) => (
                          <optgroup key={group.label} label={group.label}>
                            {group.options.map((airport) => (
                              <option key={airport.value} value={airport.value}>
                                {airport.label}
                              </option>
                            ))}
                          </optgroup>
                        ))}
                      </select>
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Date de départ *
                      </label>
                      <input
                        type="date"
                        value={safeSearchParams.departureDate}
                        onChange={(e) =>
                          setSearchParams((prev) => ({
                            ...prev,
                            departureDate: e.target.value,
                          }))
                        }
                        min={new Date().toISOString().split("T")[0]}
                        className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                        required
                      />
                    </div>

                    {safeSearchParams.tripType === "round-trip" && (
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          Date de retour *
                        </label>
                        <input
                          type="date"
                          value={safeSearchParams.returnDate}
                          onChange={(e) =>
                            setSearchParams((prev) => ({
                              ...prev,
                              returnDate: e.target.value,
                            }))
                          }
                          min={
                            safeSearchParams.departureDate ||
                            new Date().toISOString().split("T")[0]
                          }
                          className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                          required
                        />
                      </div>
                    )}

                    {/* Champs pour passagers et classe */}
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Adultes
                      </label>
                      <select
                        value={safeSearchParams.adults}
                        onChange={(e) =>
                          setSearchParams((prev) => ({
                            ...prev,
                            adults: e.target.value,
                          }))
                        }
                        className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                      >
                        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => (
                          <option key={n} value={n}>
                            {n} adulte{n > 1 ? "s" : ""}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Enfants
                      </label>
                      <select
                        value={searchParams.children}
                        onChange={(e) =>
                          setSearchParams({
                            ...searchParams,
                            children: e.target.value,
                          })
                        }
                        className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                      >
                        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => (
                          <option key={n} value={n}>
                            {n} enfant{n > 1 ? "s" : ""}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Bébés
                      </label>
                      <select
                        value={searchParams.infants}
                        onChange={(e) =>
                          setSearchParams({
                            ...searchParams,
                            infants: e.target.value,
                          })
                        }
                        className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                      >
                        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => (
                          <option key={n} value={n}>
                            {n} bébé{n > 1 ? "s" : ""}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Classe
                      </label>
                      <select
                        value={safeSearchParams.travelClass}
                        onChange={(e) =>
                          setSearchParams((prev) => ({
                            ...prev,
                            travelClass: e.target.value,
                          }))
                        }
                        className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                      >
                        <option value="ECONOMY">Économique</option>
                        <option value="PREMIUM_ECONOMY">Éco. Premium</option>
                        <option value="BUSINESS">Affaires</option>
                        <option value="FIRST">Première</option>
                      </select>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Bouton de recherche */}
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white py-4 rounded-xl font-bold text-lg disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
            >
              {loading ? (
                <>
                  <Loader className="w-6 h-6 mr-3 animate-spin" />
                  Recherche en cours...
                </>
              ) : (
                <>
                  <Search className="w-6 h-6 mr-3" />
                  {safeSearchParams.tripType === "multi-city"
                    ? `Rechercher ${multiCitySegments.length} vol${
                        multiCitySegments.length > 1 ? "s" : ""
                      }`
                    : "Rechercher des vols"}
                </>
              )}
            </button>
          </form>
        </div>

        {/* Message d'erreur */}
        {error && (
          <div className="bg-red-50 border border-red-200 rounded-lg p-4">
            <p className="text-red-600">{error}</p>
          </div>
        )}

        {/* Section des filtres */}
        {searchResults.length > 0 && <FiltersSection />}

        {/* Résultats de recherche */}
        {filteredResults.length > 0 ? (
          <div className="bg-white rounded-xl shadow-md p-6">
            <h3 className="text-xl font-bold mb-4 flex items-center justify-between">
              <span>
                {safeSearchParams.tripType === "multi-city"
                  ? `Vols trouvés pour ${filteredResults.length} segment${
                      filteredResults.length > 1 ? "s" : ""
                    }`
                  : `${filteredResults.length} vol${
                      filteredResults.length > 1 ? "s" : ""
                    } trouvé${filteredResults.length > 1 ? "s" : ""}`}
              </span>
              {searchResults.length !== filteredResults.length && (
                <span className="text-sm font-normal text-gray-500">
                  (filtrés sur {searchResults.length} résultat
                  {searchResults.length > 1 ? "s" : ""})
                </span>
              )}
            </h3>

            {safeSearchParams.tripType === "multi-city" ? (
              // AFFICHAGE MULTI-DESTINATIONS
              <div className="space-y-6">
                {filteredResults.map((segmentGroup, segmentIndex) => (
                  <div
                    key={segmentIndex}
                    className="border-2 border-blue-200 rounded-lg p-5 bg-blue-50"
                  >
                    <div className="flex items-center mb-4">
                      <div className="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold mr-3">
                        {segmentIndex + 1}
                      </div>
                      <h4 className="text-lg font-bold text-blue-900">
                        {segmentGroup.segment.origin} →{" AL "}
                        {segmentGroup.segment.destination}
                      </h4>
                    </div>

                    <div className="space-y-4">
                      {segmentGroup.flights.map((flight, flightIndex) => {
                        const firstSegment =
                          flight.itineraries?.[0]?.segments?.[0];
                        const lastSegment =
                          flight.itineraries?.[0]?.segments?.[
                            flight.itineraries[0].segments.length - 1
                          ];
                        // const segments = flight.itineraries?.[0]?.segments || [];
                        const isInCart = cart.some(
                          (c) =>
                            c.segmentId === `${segmentIndex}-${flightIndex}`
                        );

                        // Obtenir les numéros de vol et détails des segments
                        const flightNumbers = getFlightNumbers(flight);
                        const segmentsDetails =
                          getFlightSegmentsDetails(flight);
                        const hasMultipleSegments = segmentsDetails.length > 1;

                        return (
                          <div
                            key={flightIndex}
                            className="bg-white rounded-lg p-4 hover:shadow-md transition"
                          >
                            <div className="flex justify-between items-start">
                              <div className="flex-1">
                                {/* En-tête avec numéro de vol bien visible */}
                                <div className="flex items-center space-x-3 mb-3">
                                  <h5 className="font-semibold text-lg">
                                    {firstSegment?.departure?.iataCode} →{" "}
                                    {lastSegment?.arrival?.iataCode}
                                  </h5>
                                  <span className="px-2 py-1 bg-green-100 text-green-700 rounded text-sm font-medium">
                                    {getAirlineName(
                                      firstSegment?.carrierCode || ""
                                    )}
                                    {/* {flightNumbers} */}
                                  </span>
                                  {/* <span className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-sm font-semibold">
                                    {flightNumbers}
                                  </span> */}
                                  {hasMultipleSegments && (
                                    <span className="px-2 py-1 bg-orange-100 text-orange-700 rounded text-xs">
                                      {segmentsDetails.length - 1} escale
                                      {segmentsDetails.length - 1 > 1
                                        ? "s"
                                        : ""}
                                    </span>
                                  )}
                                  <span className="px-2 py-1 bg-green-100 text-green-700 rounded text-xs">
                                    {flight.travelerPricings?.[0]
                                      ?.fareDetailsBySegment?.[0]?.cabin ||
                                      "ECONOMY"}
                                  </span>
                                </div>

                                {/* Détails du vol */}
                                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm text-gray-600 mb-3">
                                  <div>
                                    <span className="font-semibold">
                                      Départ:
                                    </span>{" "}
                                    {firstSegment?.departure?.at
                                      ? new Date(
                                          firstSegment.departure.at
                                        ).toLocaleTimeString("fr-FR", {
                                          hour: "2-digit",
                                          minute: "2-digit",
                                        })
                                      : "N/A"}
                                  </div>
                                  <div>
                                    <span className="font-semibold">
                                      Arrivée:
                                    </span>{" "}
                                    {lastSegment?.arrival?.at
                                      ? new Date(
                                          lastSegment.arrival.at
                                        ).toLocaleTimeString("fr-FR", {
                                          hour: "2-digit",
                                          minute: "2-digit",
                                        })
                                      : "N/A"}
                                  </div>
                                  <div>
                                    <span className="font-semibold">
                                      Durée:
                                    </span>{" "}
                                    {flight.itineraries?.[0]?.duration
                                      ?.replace("PT", "")
                                      .replace("H", "h ")
                                      .replace("M", "min") || "N/A"}
                                  </div>
                                  <div>
                                    <span className="font-semibold">
                                      Passagers:
                                    </span>{" "}
                                    {totalPassengers}
                                  </div>
                                </div>

                                {/* Détails des segments pour les vols avec escales */}
                                {hasMultipleSegments && (
                                  <div className="bg-gray-50 rounded p-3 mb-3">
                                    <p className="text-xs font-semibold text-gray-700 mb-2">
                                      Détail de l'itinéraire :
                                    </p>
                                    <div className="space-y-2">
                                      {segmentsDetails.map(
                                        (segment, segIndex) => (
                                          <div
                                            key={segIndex}
                                            className="flex items-center justify-between text-xs"
                                          >
                                            <div className="flex items-center space-x-3">
                                              <span className="font-semibold text-blue-600 min-w-[80px]">
                                                {segment.number}
                                              </span>
                                              <span className="text-gray-600">
                                                {segment.route}
                                              </span>
                                            </div>
                                            <div className="text-right text-gray-500">
                                              <div>
                                                {segment.departureTime} →{" "}
                                                {segment.arrivalTime}
                                              </div>
                                              <div className="text-xs">
                                                {segment.duration}
                                              </div>
                                            </div>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>

                              <div className="text-right ml-4 min-w-[200px]">
                                <p className="text-2xl font-bold text-blue-600">
                                  {formatPrixCFA(flight.price?.total)}
                                  {/* {flight.price?.currency} */}
                                </p>
                                <p className="text-sm text-gray-500 mb-2">
                                  Pour {totalPassengers} passager
                                  {totalPassengers > 1 ? "s" : ""}
                                </p>

                                {isInCart ? (
                                  <button
                                    disabled
                                    className="w-full bg-gray-300 text-gray-500 px-4 py-2 rounded-lg cursor-not-allowed flex items-center justify-center text-sm"
                                  >
                                    <CheckCircle className="w-4 h-4 mr-2" />
                                    {
                                      cart.filter(
                                        (item) =>
                                          item.flightData.id === flight.id
                                      ).length
                                    }{" "}
                                    ticket(s) dans le panier
                                  </button>
                                ) : (
                                  <button
                                    onClick={() =>
                                      addToCart({
                                        ...flight,
                                        searchParams: {
                                          ...segmentGroup.searchParams,
                                          adults: searchParams.adults,
                                          children: searchParams.children,
                                          infants: searchParams.infants,
                                          originLocationCode:
                                            segmentGroup.segment.origin,
                                          destinationLocationCode:
                                            segmentGroup.segment.destination,
                                          departureDate:
                                            segmentGroup.segment.date,
                                        },
                                        segmentId: `${segmentIndex}-${flightIndex}`,
                                        segment: segmentGroup.segment,
                                      })
                                    }
                                    className="w-full bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 flex items-center justify-center text-sm"
                                  >
                                    <PlusCircle className="w-4 h-4 mr-2" />
                                    Ajouter {totalPassengers} ticket(s)
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              // AFFICHAGE STANDARD (one-way/round-trip)
              <div className="space-y-4">
                {filteredResults.map((flight, index) => {
                  const firstItinerary = flight.itineraries?.[0];
                  const firstSegment = firstItinerary?.segments?.[0];
                  const lastSegment =
                    firstItinerary?.segments?.[
                      firstItinerary.segments.length - 1
                    ];
                  const numberOfStops =
                    (firstItinerary?.segments?.length || 1) - 1;
                  const isInCart = cart.some((c) => c.id === flight.id);

                  // Obtenir les numéros de vol et détails des segments
                  const flightNumbers = getFlightNumbers(flight);
                  const segmentsDetails = getFlightSegmentsDetails(flight);
                  const hasMultipleSegments = segmentsDetails.length > 1;

                  return (
                    <div
                      key={flight.id || `flight-${index}`}
                      className="border rounded-lg p-4 hover:shadow-lg transition"
                    >
                      <div className="flex justify-between items-start">
                        <div className="flex-1">
                          {/* En-tête avec numéro de vol bien visible */}
                          <div className="flex items-center space-x-4 mb-3">
                            <h4 className="font-bold text-xl">
                              {firstSegment?.departure?.iataCode || "N/A"} →{" "}
                              {lastSegment?.arrival?.iataCode || "N/A"}
                            </h4>

                            <span className="px-2 py-1 bg-green-100 text-green-700 rounded text-sm font-medium">
                              {getAirlineName(firstSegment?.carrierCode || "")}
                            </span>

                            {/* <span className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-sm font-semibold">
                              {flightNumbers}
                            </span> */}
                            {numberOfStops > 0 ? (
                              <span className="px-3 py-1 bg-orange-100 text-orange-700 rounded-full text-sm">
                                {numberOfStops} escale
                                {numberOfStops > 1 ? "s" : ""}
                              </span>
                            ) : (
                              <span className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-sm">
                                Vol direct
                              </span>
                            )}
                          </div>

                          {/* Détails du vol */}
                          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm mb-3">
                            <div>
                              <p className="text-gray-500">Départ</p>
                              <p className="font-semibold">
                                {firstSegment?.departure?.at
                                  ? new Date(
                                      firstSegment.departure.at
                                    ).toLocaleString("fr-FR", {
                                      day: "2-digit",
                                      month: "short",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                    })
                                  : "N/A"}
                              </p>
                            </div>
                            <div>
                              <p className="text-gray-500">Arrivée</p>
                              <p className="font-semibold">
                                {lastSegment?.arrival?.at
                                  ? new Date(
                                      lastSegment.arrival.at
                                    ).toLocaleString("fr-FR", {
                                      day: "2-digit",
                                      month: "short",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                    })
                                  : "N/A"}
                              </p>
                            </div>
                            <div>
                              <p className="text-gray-500">Durée</p>
                              <p className="font-semibold">
                                {firstItinerary?.duration
                                  ?.replace("PT", "")
                                  .replace("H", "h ")
                                  .replace("M", "min") || "N/A"}
                              </p>
                            </div>
                            <div>
                              <p className="text-gray-500">Classe</p>
                              <p className="font-semibold">
                                {flight.travelerPricings?.[0]
                                  ?.fareDetailsBySegment?.[0]?.cabin ||
                                  "ECONOMY"}
                              </p>
                            </div>
                          </div>

                          {/* Détails des segments pour les vols avec escales */}
                          {hasMultipleSegments && (
                            <div className="bg-gray-50 rounded p-3 mb-3">
                              <p className="text-xs font-semibold text-gray-700 mb-2">
                                Détail de l'itinéraire :
                              </p>
                              <div className="space-y-2">
                                {segmentsDetails.map((segment, segIndex) => (
                                  <div
                                    key={segIndex}
                                    className="flex items-center justify-between text-xs"
                                  >
                                    <div className="flex items-center space-x-3">
                                      <span className="font-semibold text-blue-600 min-w-[80px]">
                                        {segment.number}
                                      </span>
                                      <span className="text-gray-600">
                                        {segment.route}
                                      </span>
                                    </div>
                                    <div className="text-right text-gray-500">
                                      <div>
                                        {segment.departureTime} →{" "}
                                        {segment.arrivalTime}
                                      </div>
                                      <div className="text-xs">
                                        {segment.duration}
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>

                        {/* Prix et bouton d'ajout */}
                        <div className="ml-4 min-w-[200px]">
                          <div className="text-right">
                            <p className="text-sm text-gray-500">Prix total</p>
                            <p className="text-3xl font-bold text-blue-600">
                              {formatPrixCFA(flight.price?.total) || "0"}
                              {/* {" "}{flight.price?.currency || "EUR"} */}
                            </p>
                            <p className="text-xs text-gray-500 mt-1">
                              Pour {totalPassengers} passager
                              {totalPassengers > 1 ? "s" : ""}
                            </p>
                          </div>
                          {isInCart ? (
                            <button
                              disabled
                              className="mt-3 w-full bg-gray-300 text-gray-500 px-4 py-2 rounded-lg cursor-not-allowed flex items-center justify-center text-sm"
                            >
                              <CheckCircle className="w-4 h-4 mr-2" />
                              {
                                cart.filter(
                                  (item) => item.flightData.id === flight.id
                                ).length
                              }{" "}
                              ticket(s) dans le panier
                            </button>
                          ) : (
                            <button
                              onClick={() => {
                                addToCart({
                                  ...flight,
                                  searchParams: {
                                    originLocationCode:
                                      firstSegment?.departure?.iataCode,
                                    destinationLocationCode:
                                      lastSegment?.arrival?.iataCode,
                                    departureDate:
                                      firstSegment?.departure?.at?.split(
                                        "T"
                                      )[0],
                                    adults: searchParams.adults,
                                    children: searchParams.children,
                                    infants: searchParams.infants,
                                    travelClass:
                                      flight.travelerPricings?.[0]
                                        ?.fareDetailsBySegment?.[0]?.cabin ||
                                      "ECONOMY",
                                    tripType: searchParams.tripType,
                                  },
                                });
                              }}
                              className="mt-3 w-full bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 flex items-center justify-center text-sm"
                            >
                              <PlusCircle className="w-4 h-4 mr-2" />
                              Ajouter {totalPassengers} ticket(s)
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        ) : searchResults.length > 0 ? (
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 text-center">
            <h4 className="text-lg font-semibold text-yellow-800 mb-2">
              Aucun vol ne correspond à vos filtres
            </h4>
            <button
              onClick={() =>
                setFilters({
                  priceRange: [0, 500000000],
                  maxStops: null,
                  departureTime: "",
                  sortBy: "price",
                })
              }
              className="bg-yellow-500 text-white px-6 py-2 rounded-lg hover:bg-yellow-600"
            >
              Réinitialiser les filtres
            </button>
          </div>
        ) : null}
      </div>
    );
  };
  // Ajouter cet onglet à votre navigation existante
  const renderTabs = () => {
    switch (activeTab) {
      case "search":
        return (
          <SearchTab
            searchParams={searchParams}
            setSearchParams={setSearchParams}
            handleSearch={handleSearch}
            loading={loading}
            error={error}
            searchResults={searchResults}
            addToCart={addToCart}
            cart={cart}
          />
        );
      case "cart":
        return <CartTab />; // Retirer onFinalize car maintenant géré par le bouton
      case "finalize": // Changé de 'form' à 'finalize'
        return (
          <FinalizeFlightRequestWorkflow
            searchParams={searchParams} // ← Ce paramètre doit être passé
            cart={cart}
            setCart={setCart}
            user={user}
            onRequestSubmitted={onRequestSubmitted}
            onBackToCart={handleBackToCart}
          />
        );
      default:
        return <SearchTab />;
    }
  };

  // RENDU PRINCIPAL
  return (
    <div className="space-y-6">
      {/* Header avec navigation */}
      <div className="bg-white rounded-xl shadow-md p-6">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold flex items-center">
            <Plane className="w-6 h-6 mr-2 text-blue-600" />
            Réservation de vols Aller simple /Aller-Retour / Multi-Vols
          </h1>
          <button
            onClick={() => setActiveTab("cart")}
            className="relative bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 flex items-center"
          >
            <ShoppingCart className="w-5 h-5 mr-2" />
            Mon Panier
            {cart.length > 0 && (
              <span className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold">
                {cart.length}
              </span>
            )}
          </button>
        </div>

        {/* Navigation améliorée */}
        <div className="flex space-x-2 border-b overflow-x-auto">
          <button
            onClick={() => setActiveTab("search")}
            className={`px-6 py-3 font-semibold border-b-2 transition ${
              activeTab === "search"
                ? "border-blue-600 text-blue-600"
                : "border-transparent text-gray-600 hover:text-blue-600"
            }`}
          >
            <Search className="w-5 h-5 inline mr-2" />
            Rechercher
          </button>
          <button
            onClick={() => setActiveTab("cart")}
            className={`px-6 py-3 font-semibold border-b-2 transition ${
              activeTab === "cart"
                ? "border-blue-600 text-blue-600"
                : "border-transparent text-gray-600 hover:text-blue-600"
            }`}
          >
            <ShoppingCart className="w-5 h-5 inline mr-2" />
            Panier ({cart.length})
          </button>
          {cart.length > 0 && (
            <button
              onClick={() => setActiveTab("finalize")}
              className={`px-6 py-3 font-semibold border-b-2 transition ${
                activeTab === "finalize"
                  ? "border-blue-600 text-blue-600"
                  : "border-transparent text-gray-600 hover:text-blue-600"
              }`}
            >
              <FileText className="w-5 h-5 inline mr-2" />
              Finaliser
            </button>
          )}
        </div>
      </div>

      {/* Contenu */}
      {renderTabs()}
    </div>
  );
};

const FinalizeFlightRequestWorkflow = ({
  searchParams,
  setCart,
  cart,
  user,
  onRequestSubmitted,
  onBackToCart,
}) => {
  const [activeStep, setActiveStep] = useState("agent");
  const [formData, setFormData] = useState({
    agentId: "",
    objetVoyage: "",
    motifDeplacement: "",
    projet: "",
    centreCoût: "",
  });

  // Gestion sécurisée de searchParams

  const [safeSearchParams, setSafeSearchParams] = useState(
    searchParams || {
      tripType: "one-way",
      originLocationCode: "",
      destinationLocationCode: "",
      departureDate: new Date().toISOString().split("T")[0],
      adults: "1",
      children: "0",
      infants: "0",
      travelClass: "ECONOMY",
    }
  );
  console.log("searchParams reçus:", searchParams);
  console.log("safeSearchParams utilisés:", safeSearchParams);

  const [agents, setAgents] = useState([]);
  const [loadingAgents, setLoadingAgents] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);

  // Chargement des agents
  useEffect(() => {
    loadAgents();
  }, []);

  const loadAgents = async () => {
    setLoadingAgents(true);
    try {
      const response = await fetch(`${API_BASE_URL2}/travel-agents`);
      if (!response.ok) throw new Error("Erreur récupération agents");
      const agentsData = await response.json();
      setAgents(agentsData);
    } catch (error) {
      console.error("Erreur chargement agents:", error);
      toast.error("Impossible de charger la liste des agents");
    } finally {
      setLoadingAgents(false);
    }
  };

  // Gestion stable des changements de formulaire
  const handleInputChange = useCallback((field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  }, []);

  const handleAgentChange = useCallback(
    (agentId) => {
      setFormData((prev) => ({
        ...prev,
        agentId,
      }));
      setSelectedAgent(agents.find((a) => a.id === agentId));
    },
    [agents]
  );

  // Génération UUID
  const generateUUID = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  };

  // Calcul du total du panier
  const calculateCartTotal = () => {
      const t =cart
      .reduce((total, ticket) => {
          const ticketPrice = parseFloat(
              ticket.price?.total || ticket.flightData?.price?.total || 0
            );
            return total + ticketPrice;
        }, 0)
        .toFixed(2);
        return formatPrixCFA(t)
  };

  // Déterminer le type de vol pour chaque segment
  const getFlightTypeForSegment = (
    segmentIndex,
    totalSegments,
    globalTripType
  ) => {
    if (globalTripType === "round-trip" && totalSegments === 2) {
      return segmentIndex === 0 ? "aller" : "retour";
    } else if (globalTripType === "multi-city") {
      return `etape-${segmentIndex + 1}`;
    } else {
      return "aller-simple";
    }
  };

  // Obtenir le libellé du type de vol pour l'affichage
  const getFlightTypeLabel = (segmentIndex, totalSegments, globalTripType) => {
    if (globalTripType === "round-trip" && totalSegments === 2) {
      return segmentIndex === 0 ? "Aller" : "Retour";
    } else if (globalTripType === "multi-city") {
      return `Étape ${segmentIndex + 1}`;
    } else {
      return "Vol";
    }
  };

  // Soumission finale corrigée

  const handleFinalSubmit = async (e) => {
    console.log("Début de la soumission");
    e.preventDefault();

    if (
      !formData.agentId ||
      !formData.objetVoyage ||
      !formData.motifDeplacement
    ) {
      toast.info("Veuillez remplir tous les champs obligatoires");
      return;
    }

    if (submitting) {
      console.log("Soumission déjà en cours...");
      return;
    }

    setSubmitting(true);

    try {
      const agent = agents.find((a) => a.id === formData.agentId);
      if (!agent) {
        toast.info("Agent sélectionné introuvable");
        setSubmitting(false);
        return;
      }

      if (cart.length === 0) {
        toast.info("Aucun vol dans le panier");
        setSubmitting(false);
        return;
      }

      console.log("DONNEES DU VOL", cart);
      // Construction de la demande avec TOUS les vols dans un tableau
      const requestData = {
        // Pas d'ID - il sera généré côté serveur
        numeroRequete: `VOL-${Date.now()}`,

        // Informations de l'agent
        matricule: agent.matricule,
        nom: agent.nom,
        prenom: agent.prenom,
        categorie: agent.categorie,
        fonction: agent.fonction,
        agentId: agent.id,

        // Détails du voyage
        objetVoyage: formData.objetVoyage,
        motifDeplacement: formData.motifDeplacement,
        projet: formData.projet || "",
        centreCoût: formData.centreCoût || "",

        // Vol en tant que TABLEAU d'objets
        vol: cart.map((flight, index) => {
          // Récupérer les données depuis la structure existante
          const flightData = flight.flightData || flight;
          const firstItinerary = flightData.itineraries?.[0];
          const firstSegment = firstItinerary?.segments?.[0];
          const lastSegment =
            firstItinerary?.segments?.[firstItinerary.segments.length - 1];

          return {
            id:
              flight.cartId ||
              flight.id ||
              `${flightData.id}-${Date.now()}-${index}`,
            flightData: {
              type: flightData.type || "flight-offer",
              id: flightData.id,
              source: flightData.source || "GDS",
              instantTicketingRequired:
                flightData.instantTicketingRequired || false,
              nonHomogeneous: flightData.nonHomogeneous || false,
              oneWay: flightData.oneWay || false,
              isUpsellOffer: flightData.isUpsellOffer || false,
              lastTicketingDate: flightData.lastTicketingDate,
              lastTicketingDateTime: flightData.lastTicketingDateTime,
              numberOfBookableSeats: flightData.numberOfBookableSeats,
              itineraries: flightData.itineraries,
              price: flightData.price,
              pricingOptions: flightData.pricingOptions,
              validatingAirlineCodes: flightData.validatingAirlineCodes,
              travelerPricings: flightData.travelerPricings,

              // SearchParams avec les bonnes références
              searchParams: flightData.searchParams || {
                originLocationCode: firstSegment?.departure?.iataCode || "",
                destinationLocationCode: lastSegment?.arrival?.iataCode || "",
                departureDate:
                  flightData.searchParams?.departureDate ||
                  flight.searchParams?.departureDate ||
                  new Date().toISOString().split("T")[0],
                adults:
                  flightData.searchParams?.adults ||
                  flight.searchParams?.adults ||
                  "1",
                children:
                  flightData.searchParams?.children ||
                  flight.searchParams?.children ||
                  "0",
                infants:
                  flightData.searchParams?.infants ||
                  flight.searchParams?.infants ||
                  "0",
                travelClass:
                  flightData.searchParams?.travelClass ||
                  flight.searchParams?.travelClass ||
                  "ECONOMY",
                tripType:
                  flightData.searchParams?.tripType ||
                  flight.searchParams?.tripType ||
                  safeSearchParams.tripType ||
                  "one-way",
              },

              // Departure avec les bonnes données
              departure: flightData.departure || {
                iataCode: firstSegment?.departure?.iataCode || "",
                at: firstSegment?.departure?.at || "",
              },

              // Arrival avec les bonnes données
              arrival: flightData.arrival || {
                iataCode: lastSegment?.arrival?.iataCode || "",
                at: lastSegment?.arrival?.at || "",
              },

              // Airline avec toutes les infos disponibles
              airline: flightData.airline || {
                code:
                  firstSegment?.carrierCode ||
                  flightData.validatingAirlineCodes?.[0] ||
                  "",
                name: getAirlineName(
                  firstSegment?.carrierCode ||
                    flightData.validatingAirlineCodes?.[0] ||
                    ""
                ),
                number: firstSegment?.number || "",
              },

              // Durée et segments
              duration: flightData.duration || firstItinerary?.duration || "",
              segments: flightData.segments || firstItinerary?.segments || [],
            },

            // Métadonnées du passager et du vol
            passengerType: flight.passengerType || "ADULT",
            passengerNumber:
              flight.passengerNumber ||
              parseInt(flightData.searchParams?.adults || "1"),

            // Prix du ticket
            price: flight.price || {
              total:
                flightData.price?.grandTotal || flightData.price?.total || "0",
              currency: flightData.price?.currency || "EUR",
            },

            // SearchParams au niveau du vol
            searchParams: flightData.searchParams || flight.searchParams || {},

            // Horodatage
            addedAt: flight.addedAt || new Date().toISOString(),

            // Position dans le voyage
            segmentNumber: index + 1,
            flightType: getFlightTypeForSegment(
              index,
              cart.length,
              safeSearchParams.tripType
            ),
            flightTypeLabel: getFlightTypeLabel(
              index,
              cart.length,
              safeSearchParams.tripType
            ),
            isOutbound:
              safeSearchParams.tripType === "round-trip" && index === 0,
            isReturn: safeSearchParams.tripType === "round-trip" && index === 1,
            isMultiCitySegment: safeSearchParams.tripType === "multi-city",
          };
        }),

        // Montant total de tous les vols
        montant:
          parseInt(calculateCartTotal().replace(/\D/g, "")) ||
          cart
            .reduce((sum, flight) => {
              const flightData = flight.flightData || flight;
              const price = parseFloat(
                flightData.price?.grandTotal ||
                  flightData.price?.total ||
                  flight.price?.total ||
                  0
              );
              return sum + price;
            }, 0)
            .toFixed(2),

        devise:
          cart[0]?.flightData?.price?.currency ||
          cart[0]?.price?.currency ||
          "EUR",

        // Statut
        statut: "En attente",

        // ID du créateur
        createdById: user.id,

        // SearchParams global avec les bonnes références
        searchParams: {
          originLocationCode:
            cart[0]?.flightData?.searchParams?.originLocationCode ||
            cart[0]?.searchParams?.originLocationCode ||
            cart[0]?.flightData?.itineraries?.[0]?.segments?.[0]?.departure
              ?.iataCode ||
            "",
          destinationLocationCode:
            cart[cart.length - 1]?.flightData?.searchParams
              ?.destinationLocationCode ||
            cart[cart.length - 1]?.searchParams?.destinationLocationCode ||
            cart[cart.length - 1]?.flightData?.itineraries?.[0]?.segments?.[
              cart[cart.length - 1]?.flightData?.itineraries?.[0]?.segments
                ?.length - 1
            ]?.arrival?.iataCode ||
            "",
          departureDate:
            cart[0]?.flightData?.searchParams?.departureDate ||
            cart[0]?.searchParams?.departureDate ||
            new Date().toISOString().split("T")[0],
          adults:
            cart[0]?.flightData?.searchParams?.adults ||
            cart[0]?.searchParams?.adults ||
            "1",
          tripType: safeSearchParams.tripType || "one-way",
          travelClass:
            cart[0]?.flightData?.searchParams?.travelClass ||
            cart[0]?.searchParams?.travelClass ||
            "ECONOMY",
          numberOfFlights: cart.length,
          journeyStructure: {
            totalSegments: cart.length,
            isRoundTrip: safeSearchParams.tripType === "round-trip",
            isMultiCity: safeSearchParams.tripType === "multi-city",
            isOneWay: safeSearchParams.tripType === "one-way",
          },
        },
      };

      console.log("Création de la demande multi-vols:", requestData);
      console.log("Nombre de vols dans la demande:", requestData.vol.length);

      const response = await fetch(`${API_BASE_URL2}/flight-requests`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const responseData = await response.json();

      if (!response.ok) {
        console.error("Erreur API:", responseData);
        throw new Error(
          responseData.message ||
            "Erreur lors de la création de la demande de vol"
        );
      }

      const typeVoyage =
        safeSearchParams.tripType === "round-trip"
          ? "aller-retour"
          : safeSearchParams.tripType === "multi-city"
          ? "multi-destinations"
          : "aller simple";

      toast.success(
        `Demande de vol ${typeVoyage} créée avec succès ! (${cart.length} vol${
          cart.length > 1 ? "s" : ""
        } inclus)\nNuméro: ${requestData.numeroRequete}`
      );

      // Réinitialisation après succès
      setCart([]);
      setFormData({
        agentId: "",
        objetVoyage: "",
        motifDeplacement: "",
        projet: "",
        centreCoût: "",
      });
      setSubmitting(false);
      setSafeSearchParams({
        originLocationCode: "",
        destinationLocationCode: "",
        departureDate: "",
        returnDate: "",
        adults: "1",
        children: "0",
        infants: "0",
        tripType: "one-way",
        travelClass: "ECONOMY",
      });
      setActiveStep("search");

      if (onRequestSubmitted) {
        onRequestSubmitted(responseData);
      }

      console.log("✅ Soumission terminée avec succès");
    } catch (error) {
      console.error("❌ Erreur soumission demande:", error);
      toast.error(`Erreur: ${error.message}`);
      setSubmitting(false);
    }
  };
  // Composant TravelDetailsStep corrigé avec useCallback
  // Composant TravelDetailsStep corrigé

  // Étape 1: Sélection de l'agent
  const AgentSelectionStep = () => (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-md p-6">
        <h3 className="text-xl font-bold mb-4 flex items-center">
          <Users className="w-6 h-6 mr-2 text-blue-600" />
          Sélection de l'Agent Voyageur
        </h3>

        <div className="mb-6">
          <label className="block text-sm font-semibold mb-3">
            Choisir l'agent qui effectuera le voyage *
          </label>
          <select
            value={formData.agentId}
            onChange={(e) => {
              const agentId = e.target.value;
              setFormData({ ...formData, agentId });
              setSelectedAgent(agents.find((a) => a.id === agentId));
            }}
            className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition"
            required
            disabled={loadingAgents}
          >
            <option value="">-- Sélectionner un agent --</option>
            {agents.map((agent) => (
              <option key={agent.id} value={agent.id}>
                {agent.prenom} {agent.nom} - {agent.fonction} (Matricule:{" "}
                {agent.matricule})
              </option>
            ))}
          </select>

          {loadingAgents && (
            <p className="text-sm text-gray-500 mt-2 flex items-center">
              <Loader className="w-4 h-4 mr-2 animate-spin" />
              Chargement des agents...
            </p>
          )}
        </div>

        {selectedAgent && (
          <div className="bg-green-50 border border-green-200 rounded-lg p-4">
            <h4 className="font-semibold text-green-800 mb-2">
              Agent sélectionné :
            </h4>
            <div className="grid grid-cols-2 gap-2 text-sm">
              <div>
                <span className="text-gray-600">Nom :</span>
                <span className="font-semibold ml-2">
                  {selectedAgent.prenom} {selectedAgent.nom}
                </span>
              </div>
              <div>
                <span className="text-gray-600">Fonction :</span>
                <span className="font-semibold ml-2">
                  {selectedAgent.fonction}
                </span>
              </div>
              <div>
                <span className="text-gray-600">Matricule :</span>
                <span className="font-semibold ml-2">
                  {selectedAgent.matricule}
                </span>
              </div>
              <div>
                <span className="text-gray-600">Catégorie :</span>
                <span className="font-semibold ml-2">
                  {selectedAgent.categorie}
                </span>
              </div>
            </div>
          </div>
        )}

        <div className="flex justify-between mt-6">
          <button
            type="button"
            onClick={onBackToCart}
            className="px-6 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 flex items-center transition"
          >
            <ChevronLeft className="w-5 h-5 mr-2" />
            Retour au panier
          </button>
          <button
            type="button"
            onClick={() => formData.agentId && setActiveStep("details")}
            disabled={!formData.agentId}
            className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center transition"
          >
            Continuer
            <ChevronRight className="w-5 h-5 ml-2" />
          </button>
        </div>
      </div>
    </div>
  );

  // Résumé du panier (affiché sur toutes les étapes)
  const CartSummary = () => {
    // Fonction pour formater la durée
    const formatDuration = (duration) => {
      if (!duration) return "N/A";
      const match = duration.match(/PT(?:(\d+)H)?(?:(\d+)M)?/);
      const hours = match[1] ? parseInt(match[1]) : 0;
      const minutes = match[2] ? parseInt(match[2]) : 0;

      if (hours > 0 && minutes > 0) {
        return `${hours}h ${minutes}min`;
      } else if (hours > 0) {
        return `${hours}h`;
      } else {
        return `${minutes}min`;
      }
    };

    // Fonction pour obtenir le nom de la compagnie

    // Grouper les tickets par vol (même flightData.id)
    const groupedTickets = cart.reduce((groups, ticket) => {
      const flightId = ticket.flightData?.id || ticket.id;
      if (!groups[flightId]) {
        groups[flightId] = [];
      }
      groups[flightId].push(ticket);
      return groups;
    }, {});

    // Calculer les totaux par type de passager
    const totalAdults = cart.filter(
      (ticket) => ticket.passengerType === "ADULT"
    ).length;
    const totalChildren = cart.filter(
      (ticket) => ticket.passengerType === "CHILD"
    ).length;
    const totalInfants = cart.filter(
      (ticket) => ticket.passengerType === "INFANT"
    ).length;
    const totalPassengers = totalAdults + totalChildren + totalInfants;

    // Obtenir le libellé du type de voyage
    const getTripTypeLabel = () => {
      switch (safeSearchParams.tripType) {
        case "one-way":
          return "Demande Aller Simple";
        case "round-trip":
          return "Demande Aller-Retour";
        case "multi-city":
          return "Demande Multi-Destinations";
        default:
          return "Demande de Vols";
      }
    };

    // Obtenir le libellé pour un vol spécifique
    const getFlightLabel = (index, totalFlights) => {
      return getFlightTypeLabel(index, totalFlights, safeSearchParams.tripType);
    };

    // Obtenir la couleur pour le badge du vol
    const getFlightBadgeColor = (index, totalFlights) => {
      if (safeSearchParams.tripType === "round-trip" && totalFlights === 2) {
        return index === 0
          ? "bg-green-100 text-green-700"
          : "bg-blue-100 text-blue-700";
      } else if (safeSearchParams.tripType === "multi-city") {
        return "bg-purple-100 text-purple-700";
      } else {
        return "bg-blue-100 text-blue-700";
      }
    };

    // Obtenir la description du trajet
    const getJourneyDescription = () => {
      const flightCount = Object.keys(groupedTickets).length;

      switch (safeSearchParams.tripType) {
        case "one-way":
          return `${flightCount} vol${flightCount > 1 ? "s" : ""} aller simple`;
        case "round-trip":
          return `${flightCount} vol${flightCount > 1 ? "s" : ""} aller-retour`;
        case "multi-city":
          return `${flightCount} étape${
            flightCount > 1 ? "s" : ""
          } multi-destinations`;
        default:
          return `${flightCount} vol${flightCount > 1 ? "s" : ""}`;
      }
    };

    // Obtenir l'icône selon le type de voyage
    const getTripTypeIcon = () => {
      switch (safeSearchParams.tripType) {
        case "one-way":
          return <Plane className="w-5 h-5 mr-2 text-blue-600" />;
        case "round-trip":
          return (
            <svg
              className="w-5 h-5 mr-2 text-blue-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
              />
            </svg>
          );
        case "multi-city":
          return <MapPin className="w-5 h-5 mr-2 text-blue-600" />;
        default:
          return <ShoppingCart className="w-5 h-5 mr-2 text-blue-600" />;
      }
    };

    return (
      <div className="bg-white rounded-xl shadow-md p-6 mb-6">
        <h3 className="text-lg font-bold mb-4 flex items-center">
          {getTripTypeIcon()}
          {getTripTypeLabel()} ({Object.keys(groupedTickets).length}{" "}
          {safeSearchParams.tripType === "multi-city" ? "étape" : "vol"}
          {Object.keys(groupedTickets).length > 1 ? "s" : ""})
        </h3>

        {/* Message d'information contextuel */}
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-4">
          <div className="flex items-center">
            <Info className="w-5 h-5 text-yellow-600 mr-2" />
            <p className="text-yellow-800 text-sm">
              <strong>Important :</strong>{" "}
              {safeSearchParams.tripType === "multi-city"
                ? "Tous les vols seront regroupés dans une seule demande multi-destinations"
                : safeSearchParams.tripType === "round-trip"
                ? "Votre demande inclut les vols aller et retour"
                : "Votre demande concerne un vol aller simple"}
            </p>
          </div>
        </div>

        <div className="space-y-4 mb-4">
          {Object.entries(groupedTickets).map(
            ([flightId, tickets], index, array) => {
              const firstTicket = tickets[0];
              const firstItinerary =
                firstTicket.flightData?.itineraries?.[0] ||
                firstTicket.itineraries?.[0];
              const firstSegment = firstItinerary?.segments?.[0];
              const lastSegment =
                firstItinerary?.segments?.[
                  firstItinerary?.segments?.length - 1
                ];
              const carrierCode = firstSegment?.carrierCode;
              const flightNumber = firstSegment?.number;

              // Compter les passagers par type pour ce vol
              const adults = tickets.filter(
                (t) => t.passengerType === "ADULT"
              ).length;
              const children = tickets.filter(
                (t) => t.passengerType === "CHILD"
              ).length;
              const infants = tickets.filter(
                (t) => t.passengerType === "INFANT"
              ).length;

              return (
                <div
                  key={flightId}
                  className="border border-gray-200 rounded-lg p-4"
                >
                  <div className="flex justify-between items-start">
                    <div className="flex-1">
                      {/* En-tête du vol */}
                      <div className="flex items-center space-x-3 mb-3">
                        <span
                          className={`px-3 py-1 rounded-full text-sm font-semibold ${getFlightBadgeColor(
                            index,
                            array.length
                          )}`}
                        >
                          {getFlightLabel(index, array.length)}
                        </span>
                        <h4 className="font-bold text-gray-800">
                          {firstSegment?.departure?.iataCode ||
                            firstTicket.flightData?.departure?.iataCode ||
                            "N/A"}{" "}
                          →
                          {lastSegment?.arrival?.iataCode ||
                            firstTicket.flightData?.arrival?.iataCode ||
                            "N/A"}
                        </h4>
                        <span className="px-2 py-1 bg-green-100 text-green-700 rounded text-xs font-medium">
                          {getAirlineName(
                            carrierCode || firstTicket.flightData?.airline?.code
                          )}
                          {flightNumber ? ` ${flightNumber}` : ""}
                        </span>
                      </div>

                      {/* Informations détaillées */}
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 text-sm">
                        {/* Horaires */}
                        <div>
                          <p className="text-gray-500 text-xs">Horaires</p>
                          <p className="font-semibold">
                            {firstSegment?.departure?.at ||
                            firstTicket.flightData?.departure?.at
                              ? new Date(
                                  firstSegment?.departure?.at ||
                                    firstTicket.flightData?.departure?.at
                                ).toLocaleTimeString("fr-FR", {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })
                              : "N/A"}{" "}
                            -
                            {lastSegment?.arrival?.at ||
                            firstTicket.flightData?.arrival?.at
                              ? new Date(
                                  lastSegment?.arrival?.at ||
                                    firstTicket.flightData?.arrival?.at
                                ).toLocaleTimeString("fr-FR", {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })
                              : "N/A"}
                          </p>
                        </div>

                        {/* Date et durée */}
                        <div>
                          <p className="text-gray-500 text-xs">Date & Durée</p>
                          <p className="font-semibold">
                            {firstSegment?.departure?.at
                              ? new Date(
                                  firstSegment.departure.at
                                ).toLocaleDateString("fr-FR")
                              : firstTicket.searchParams?.departureDate
                              ? new Date(
                                  firstTicket.searchParams.departureDate
                                ).toLocaleDateString("fr-FR")
                              : "N/A"}{" "}
                            •{" "}
                            {formatDuration(
                              firstItinerary?.duration ||
                                firstTicket.flightData?.duration
                            )}
                          </p>
                        </div>

                        {/* Passagers détaillés */}
                        <div>
                          <p className="text-gray-500 text-xs">Passagers</p>
                          <div className="font-semibold space-y-1">
                            {adults > 0 && (
                              <div className="flex items-center space-x-2">
                                <span className="text-blue-600">👤</span>
                                <span>
                                  {adults} adulte{adults > 1 ? "s" : ""}
                                </span>
                              </div>
                            )}
                            {children > 0 && (
                              <div className="flex items-center space-x-2">
                                <span className="text-green-600">🧒</span>
                                <span>
                                  {children} enfant{children > 1 ? "s" : ""}
                                </span>
                              </div>
                            )}
                            {infants > 0 && (
                              <div className="flex items-center space-x-2">
                                <span className="text-pink-600">👶</span>
                                <span>
                                  {infants} bébé{infants > 1 ? "s" : ""}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Détail des tickets individuels */}
                      <div className="mt-3 p-2 bg-gray-50 rounded">
                        <p className="text-xs text-gray-500 mb-1">
                          Détail des tickets :
                        </p>
                        <div className="space-y-1">
                          {tickets.map((ticket) => (
                            <div
                              key={ticket.id}
                              className="flex justify-between text-xs"
                            >
                              <span>
                                {ticket.passengerType === "ADULT"
                                  ? "👤 Adulte"
                                  : ticket.passengerType === "CHILD"
                                  ? "🧒 Enfant"
                                  : "👶 Bébé"}
                                #{ticket.passengerNumber}
                              </span>
                              <span className="font-semibold">
                                {formatPrixCFA(ticket.price?.total)}
                                 {/* {ticket.price?.currency} */}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    {/* Prix total pour ce vol */}
                    <div className="text-right ml-4">
                      <p className="text-xl font-bold text-blue-600">
                        
                        {formatPrixCFA(tickets
                          .reduce(
                            (sum, ticket) =>
                              sum + parseFloat(ticket.price?.total || 0),
                            0
                          )
                          .toFixed(2))}
                        {/* {tickets[0]?.price?.currency || "EUR"} */}
                      </p>
                      <p className="text-xs text-gray-500 mt-1">
                        {tickets.length} passager{tickets.length > 1 ? "s" : ""}
                      </p>
                    </div>
                  </div>
                </div>
              );
            }
          )}
        </div>

        {/* Résumé total */}
        <div className="flex justify-between items-center pt-4 border-t">
          <div>
            <span className="text-lg font-semibold">Total de la demande :</span>
            <div className="text-sm text-gray-600 space-y-1 mt-1">
              <p>{getJourneyDescription()}</p>
              <div className="flex items-center space-x-4">
                {totalAdults > 0 && (
                  <span className="flex items-center space-x-1">
                    <span className="text-blue-600">👤</span>
                    <span>
                      {totalAdults} adulte{totalAdults > 1 ? "s" : ""}
                    </span>
                  </span>
                )}
                {totalChildren > 0 && (
                  <span className="flex items-center space-x-1">
                    <span className="text-green-600">🧒</span>
                    <span>
                      {totalChildren} enfant{totalChildren > 1 ? "s" : ""}
                    </span>
                  </span>
                )}
                {totalInfants > 0 && (
                  <span className="flex items-center space-x-1">
                    <span className="text-pink-600">👶</span>
                    <span>
                      {totalInfants} bébé{totalInfants > 1 ? "s" : ""}
                    </span>
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="text-right">
            <span className="text-2xl font-bold text-green-600">
              {calculateCartTotal()} 
              {/* {cart[0]?.price?.currency || "EUR"} */}
            </span>
            <p className="text-sm text-gray-600 mt-1">Tous frais compris</p>
          </div>
        </div>
      </div>
    );
  };

  // Indicateur de progression
  const ProgressIndicator = () => (
    <div className="bg-white rounded-xl shadow-md p-6 mb-6">
      <div className="flex items-center justify-between">
        <div
          className={`flex items-center space-x-3 ${
            activeStep === "agent" ? "text-blue-600" : "text-gray-500"
          }`}
        >
          <div
            className={`w-8 h-8 rounded-full flex items-center justify-center ${
              activeStep === "agent" ? "bg-blue-600 text-white" : "bg-gray-200"
            }`}
          >
            1
          </div>
          <div>
            <p className="font-semibold">Agent</p>
            <p className="text-sm">Sélection du voyageur</p>
          </div>
        </div>

        <div className="flex-1 h-1 bg-gray-200 mx-4">
          <div
            className={`h-full bg-blue-600 transition-all ${
              activeStep === "details" ? "w-full" : "w-0"
            }`}
          ></div>
        </div>

        <div
          className={`flex items-center space-x-3 ${
            activeStep === "details" ? "text-blue-600" : "text-gray-500"
          }`}
        >
          <div
            className={`w-8 h-8 rounded-full flex items-center justify-center ${
              activeStep === "details"
                ? "bg-blue-600 text-white"
                : "bg-gray-200"
            }`}
          >
            2
          </div>
          <div>
            <p className="font-semibold">Détails</p>
            <p className="text-sm">Informations voyage</p>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="space-y-6">
      {/* En-tête */}
      <div className="bg-white rounded-xl shadow-md p-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold flex items-center">
              <Plane className="w-6 h-6 mr-2 text-blue-600" />
              Finalisation de la demande -{" "}
              {safeSearchParams.tripType === "round-trip"
                ? "Aller-Retour"
                : safeSearchParams.tripType === "multi-city"
                ? "Multi-Destinations"
                : "Aller Simple"}
            </h1>
            <p className="text-gray-600 mt-1">
              Complétez les informations pour soumettre votre demande de{" "}
              {safeSearchParams.tripType === "round-trip"
                ? "vols aller-retour"
                : safeSearchParams.tripType === "multi-city"
                ? "vols multi-destinations"
                : "vol aller simple"}
            </p>
          </div>
          <div className="text-right">
            <p className="text-sm text-gray-500">
              Nombre de{" "}
              {safeSearchParams.tripType === "multi-city" ? "étapes" : "vols"}
            </p>
            <p className="text-2xl font-bold text-blue-600">{cart.length}</p>
          </div>
        </div>
      </div>

      {/* Indicateur de progression */}
      <ProgressIndicator />

      {/* Résumé du panier */}
      <CartSummary />

      {/* CONTENU SELON L'ÉTAPE */}
      {activeStep === "agent" && <AgentSelectionStep />}

      {activeStep === "details" && (
        <TravelDetailsStep
          formData={formData}
          onFormDataChange={handleInputChange}
          setActiveStep={setActiveStep}
          submitting={submitting}
          onFinalSubmit={handleFinalSubmit}
        />
      )}
    </div>
  );
};

const TravelDetailsStep = ({
  formData,
  onFormDataChange,
  setActiveStep,
  submitting,
  onFinalSubmit,
  onRequestSubmitted,
}) => {
  // État local pour gérer la soumission de manière plus fiable
  const [localSubmitting, setLocalSubmitting] = useState(false);

  const isActuallySubmitting = localSubmitting || submitting;

  // Gestionnaires d'événements
  const handleMotifChange = (e) => {
    onFormDataChange("motifDeplacement", e.target.value);
  };

  const handleObjetChange = (e) => {
    onFormDataChange("objetVoyage", e.target.value);
  };

  const handleProjetChange = (e) => {
    onFormDataChange("projet", e.target.value);
  };

  const handleCentreCoutChange = (e) => {
    onFormDataChange("centreCoût", e.target.value);
  };

  // CORRECTION : Gestion améliorée de la soumission
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    // Empêcher les doubles soumissions
    if (isActuallySubmitting) {
      console.log("Soumission déjà en cours...");
      return;
    }

    // Validation des champs obligatoires
    if (!formData.objetVoyage || !formData.motifDeplacement) {
      toast.error("Veuillez remplir tous les champs obligatoires");
      return;
    }

    setLocalSubmitting(true);

    try {
      await onFinalSubmit(e);
      // Si onFinalSubmit réussit, l'état sera réinitialisé dans le parent
    } catch (error) {
      console.error("Erreur lors de la soumission du formulaire:", error);
    } finally {
      // CORRECTION : S'assurer que l'état local est toujours réinitialisé après un délai
      setTimeout(() => {
        setLocalSubmitting(false);
      }, 1000);
    }
  };

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-md p-6">
        <h3 className="text-xl font-bold mb-4 flex items-center">
          <FileText className="w-6 h-6 mr-2 text-blue-600" />
          Détails du Voyage
        </h3>

        {/* CORRECTION : Utiliser handleFormSubmit au lieu de onFinalSubmit directement */}
        <form onSubmit={handleFormSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-semibold mb-2">
              Objet du voyage *
            </label>
            <select
              value={formData.objetVoyage || ""}
              onChange={handleObjetChange}
              className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition"
              required
              disabled={isActuallySubmitting}
            >
              <option value="">Sélectionnez un objet de voyage</option>
              <option value="tournee-commerciale">Tournée commerciale</option>
              <option value="seminaire-formation">Séminaire / Formation</option>
              <option value="mission-technique">Mission technique</option>
              <option value="salon-conference">Salon / Conférence</option>
              <option value="visite-client">Visite client</option>
              <option value="audit-inspection">Audit / Inspection</option>
              <option value="reunion-partenaire">Réunion partenaire</option>
              <option value="recrutement">Recrutement</option>
              <option value="lancement-produit">Lancement de produit</option>
              <option value="negociation-contractuelle">
                Négociation contractuelle
              </option>
              <option value="support-technique">Support technique</option>
              <option value="formation-interne">Formation interne</option>
              <option value="team-building">Team building</option>
              <option value="visite-site">Visite de site</option>
              <option value="autre">Autre</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-semibold mb-2">
              Motif du déplacement *
            </label>
            <textarea
              value={formData.motifDeplacement || ""}
              onChange={handleMotifChange}
              rows="3"
              className="w-full px-4 py-2 border rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition"
              placeholder="Décrivez le motif de votre déplacement..."
              required
              disabled={isActuallySubmitting}
            />
          </div>

          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-semibold mb-2">
                Projet associé
              </label>
              <select
                value={formData.projet || ""}
                onChange={handleProjetChange}
                className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition"
                disabled={isActuallySubmitting}
              >
                <option value="">Sélectionnez un projet</option>
                <option value="projet-alpha">Projet Alpha</option>
                <option value="projet-beta">Projet Beta</option>
                <option value="projet-gamma">Projet Gamma</option>
                <option value="projet-delta">Projet Delta</option>
                <option value="expansion-regionale">Expansion Régionale</option>
                <option value="digitalisation-process">
                  Digitalisation des Processus
                </option>
                <option value="lancement-produit-2024">
                  Lancement Produit 2024
                </option>
                <option value="optimisation-couts">
                  Optimisation des Coûts
                </option>
                <option value="formation-equipe">Formation Équipe</option>
                <option value="recherche-developpement">
                  Recherche & Développement
                </option>
                <option value="aucun">Aucun projet associé</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-semibold mb-2">
                Centre de coût
              </label>
              <select
                value={formData.centreCoût || ""}
                onChange={handleCentreCoutChange}
                className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition"
                disabled={isActuallySubmitting}
              >
                <option value="">Sélectionnez un centre de coût</option>
                <option value="Groupe">Groupe</option>
                <option value="Direction Générale">Direction Générale</option>
                <option value="Direction SI">Direction SI</option>
                <option value="Direction RH">Direction RH</option>
                <option value="Direction Financière">
                  Direction Financière
                </option>
              </select>
            </div>
          </div>

          <div className="flex justify-between pt-4">
            <button
              type="button"
              onClick={() => setActiveStep("agent")}
              disabled={isActuallySubmitting}
              className="px-6 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 flex items-center transition disabled:opacity-50"
            >
              <ChevronLeft className="w-5 h-5 mr-2" />
              Retour
            </button>
            <button
              type="submit"
              disabled={
                isActuallySubmitting ||
                !formData.objetVoyage ||
                !formData.motifDeplacement
              }
              className="px-8 py-3 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-lg hover:from-green-700 hover:to-emerald-700 disabled:opacity-50 flex items-center transition"
            >
              {isActuallySubmitting ? (
                <>
                  <Loader className="w-5 h-5 mr-2 animate-spin" />
                  Soumission en cours...
                </>
              ) : (
                <>
                  <CheckCircle className="w-5 h-5 mr-2" />
                  Finaliser la demande
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
